// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-21T13:17:52.799Z
// Property: Casa Madrid  (ID: 6767906449167026)
// Collections: 14 amenities, 3 floorplans (live), 32 photos, 41 POIs, 16 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162417",
  "multihub_property_id": "6767906449167026",
  "property_external_id": "100044438",
  "property_zillow_url": "https://www.zillow.com/apartments/chula-vista-ca/casa-madrid/5XjSKN/",
  "property_apartments_url": "https://www.apartments.com/casa-madrid-chula-vista-ca/s2bd9f5/",
  "property_google_business_url": "https://www.google.com/search?hl=en-US&gl=us&q=Casa+Madrid+Apartments,+240+Quintard+St,+Chula+Vista,+CA+91911&ludocid=6689644411752449749&lsig=AB86z5WY6i8kdwPJRqMlc1DEam6g&source=g.page.m.kd._&laa=lu-desktop-review-solicitatio#laa=lu-desktop-review-solicitatio&lrd=0x80d94e8e70d97b67:0x5cd66426342e86d5,3",
  "property_linkedin_url": null,
  "property_hubspot_id": "42075941129",
  "property_crm_software": "Entrata LeadManager",
  "property_pm_software": "Entrata",
  "property_pm_info": "Entrata ",
  "property_status": null,
  "property_slug": "casa-madrid",
  "property_name": "Casa Madrid ",
  "property_website_url": "https://www.liveatcasamadrid.com/",
  "property_domain": "https://www.liveatcasamadrid.com/",
  "property_address": "240 Quintard St",
  "property_full_address": "240 Quintard St, Chula Vista, CA 91911",
  "property_address_1": "240 Quintard St",
  "property_address_2": null,
  "property_address_city": "Chula Vista",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "91911",
  "property_address_country": "US",
  "property_address_county": "San Diego County",
  "property_neighborhood_address": "Castle Park",
  "property_address_latitude": "32.6039279",
  "property_address_longitude": "-117.0621996",
  "property_email": "casamadrid@sunrisemgmt.com",
  "property_phone": "(619) 626-2010",
  "property_call_tracking_phone": "858-326-8243",
  "property_company_name": "Sunrise Management",
  "property_company_url": "https://www.sunrisemgmt.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "Welcome to Casa Madrid in Chula Vista, CA. his peaceful garden community provides all the comforts of home in an ideal location&mdash;the perfect place to call home. We take pride in offering exceptional service and quality living. Choose from",
  "property_long_description": "Welcome to Casa Madrid in Chula Vista, CA&mdash;a tranquil garden community that feels like home. Here, you&rsquo;ll enjoy all the comforts of modern living, paired with personalized attention from our warm and friendly on-site management team. Nestled in a peaceful neighborhood, Casa Madrid is ideally situated near shopping, dining, and more, offering you both beauty and convenience in one perfect location.\r\n\r\nSan Diego Sunrise Management Co. dba Sunrise Management | Lic. No. 00927850 | Broker: Joseph S. Greenblatt License number 01064415",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-601e-73e0-a977-a063aa84b481.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling swimming pool with orange lounge chairs and umbrellas at an apartment complex.",
    "public_id": "019eba82-601e-73e0-a977-a063aa84b481",
    "storage_key": "property/6767906449167026/019eba82-601e-73e0-a977-a063aa84b481.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167026/019f487d-31bc-7298-93b2-0de2a4ca5b90.mp4",
  "property_featured_video_media": {
    "public_id": "019f487d-31bc-7298-93b2-0de2a4ca5b90",
    "storage_key": "property/6767906449167026/019f487d-31bc-7298-93b2-0de2a4ca5b90.mp4",
    "thumbnail_key": "property/6767906449167026/019f487d-31bc-7298-93b2-0de2a4ca5b90_thumb.webp",
    "size_bytes": 69220915,
    "classification": "Community",
    "title": "Casa Madrid Apartment Community Tour",
    "description": "Explore the amenities and features of the Casa Madrid apartment community, including the pool, grilling area, and laundry facilities."
  },
  "property_total_units": "87",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": "76",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.25287356321839",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": "Security deposit: $250.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "100",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "30",
  "property_pet_restrictions": "Maximum 2 pets per apartment; Max weight: 30 lbs; Breed restrictions apply; breed mixes are not permitted, except for certified service or companion animals.",
  "property_pet_policy_description": "Pet deposit: $500.00 (refundable). Monthly pet rent: $50.00/month.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dog\nMax Number of Pets: 2\nMax weight of pets: 30 lbs\nPet deposit fee min: $500\nPet monthly rent min: $50\nPet policy fee min/max: $50 - $100",
  "property_online_leasing_url": "https://casamadridapts.prospectportal.com/Chula Vista/Casa Madrid",
  "property_resident_portal_url": "https://casamadridapts.residentportal.com/auth",
  "property_apply_now_url": "https://casamadridapts.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100044438/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019e98bf-3de6-7000-8aab-8d752d08e837.webp",
  "property_primary_logo_media": {
    "alt_text": "Casa Madrid logo",
    "public_id": "019e98bf-3de6-7000-8aab-8d752d08e837",
    "storage_key": "property/6767906449167026/019e98bf-3de6-7000-8aab-8d752d08e837.webp",
    "width": 1971,
    "height": 421
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019e8e4b-8448-7059-b029-44b09469776f.webp",
  "property_icon_media": {
    "alt_text": "Decorative floral tile graphic",
    "public_id": "019e8e4b-8448-7059-b029-44b09469776f",
    "storage_key": "property/6767906449167026/019e8e4b-8448-7059-b029-44b09469776f.webp",
    "width": 32,
    "height": 32
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019e98bf-9286-76f9-9e54-0024530ca00a.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Casa Madrid logo",
    "public_id": "019e98bf-9286-76f9-9e54-0024530ca00a",
    "storage_key": "property/6767906449167026/019e98bf-9286-76f9-9e54-0024530ca00a.webp",
    "width": 1280,
    "height": 273
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019e98bf-7d41-751a-9951-450819ee317b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Casa Madrid logo",
    "public_id": "019e98bf-7d41-751a-9951-450819ee317b",
    "storage_key": "property/6767906449167026/019e98bf-7d41-751a-9951-450819ee317b.webp",
    "width": 1280,
    "height": 273
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-ae4d-75a8-a6aa-7bc8aa917e90.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
  "property_company_logo_media": {
    "alt_text": "Sunrise Management logo",
    "public_id": "019d06cf-4134-73f9-aa2c-2cbcff86a11a",
    "storage_key": "company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "width": 256,
    "height": 256
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-016c-71e4-a66c-b5d1e83b79cb.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/01a15551-0100-7115-9635-6815428ea63d.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#f5f4f2",
  "property_secondary_color": "#d9d9d9",
  "property_font_color": "#3B3B3B",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 950",
  "property_sqft_min": "600",
  "property_sqft_max": "950",
  "property_price_range": "$1999 - $2999",
  "property_price_min": "1999",
  "property_price_max": "2999",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/people/Casa-Madrid/61568422708079/?mibextid=LQQJ4d",
  "property_instagram_url": "https://www.instagram.com/liveatcasamadrid",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZ3vZcI5O2YAR1YYuNCZk1lw",
  "property_youtube_url": "https://www.youtube.com/watch?t=230&v=2kiIhIBh7Gg",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Casa Madrid ",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Casa Madrid in Chula Vista, CA, where modern living meets comfort. Choose from thoughtfully designed one, two, or three-bedroom floor plans featuring stainless steel appliances and custom tile backsplashes. Enjoy our resort-style pool, BBQ area, and dog-friendly spaces—all just minutes from the 5 and 805 freeways.",
  "property_home_floorplans_blurb": "Welcome to Casa Madrid in Chula Vista, CA, where modern living meets vibrant community life. With a variety of thoughtfully designed one, two, and three-bedroom apartments, your ideal home awaits. Uncover the perfect space that fits your lifestyle and enjoy all the comforts of Casa Madrid. Browse our available floor plans today!",
  "property_home_gallery_blurb": "At Casa Madrid in vibrant Chula Vista, CA, comfort meets style in our one, two, and three-bedroom apartments. Enjoy resort-style living with a sparkling pool, BBQ area, and modern amenities like stainless steel appliances and custom tile backsplashes. Picture yourself living here and indulge in a lifestyle tailored to you!",
  "property_home_neighborhood_blurb": "Welcome to Casa Madrid in Chula Vista, CA, where spacious one, two, and three-bedroom apartments meet vibrant community life. Discover the charm of nearby attractions like the Living Coast Discovery Center, Southwestern College, and the Tijuana Arch. Embrace the best of comfort and convenience right outside your door!",
  "property_home_reviews_blurb": "At Casa Madrid in Chula Vista, our residents rave about the modern, well-maintained apartments and the attentive management team. “Gabby is very professional and easy to contact,” and thanks to Stephanie, tech troubles vanish in minutes! Join our vibrant community and enjoy events like free ice cream and tacos!",
  "property_neighborhood_blurb": "At Casa Madrid in Chula Vista, every day offers a new adventure! Enjoy the vibrant local scene with nearby gems like the Living Coast Discovery Center, Silver Strand State Beach, and the picturesque Bonita Golf Course. With diverse one to three-bedroom floor plans, you’ll find your perfect home near your favorite hangouts!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Casa Madrid in Chula Vista, CA, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom floor plans boast modern amenities like stainless steel appliances, custom tile backsplashes, and resort-style pool views. Enjoy convenience with onsite laundry, parking, and keyless entry—all in a pet-friendly environment!",
  "property_applynow_blurb": "Welcome to Casa Madrid in vibrant Chula Vista, CA, where modern living meets resort-style relaxation. Choose from spacious one to three-bedroom floor plans featuring stainless steel appliances, custom tile backsplashes, and serene vibes. Embrace a pet-friendly lifestyle and enjoy our pool and BBQ area. Lease online today!",
  "property_contactus_blurb": "At Casa Madrid in Chula Vista, CA, our thoughtfully designed one, two, and three-bedroom floor plans cater to diverse lifestyles. Each apartment is crafted to offer comfort and style. Have questions? Our dedicated leasing team is ready to assist you in finding your perfect home! Reach out today!",
  "property_faqs_blurb": "At Casa Madrid in Chula Vista, CA, our thoughtfully designed floor plans—ranging from one to three bedrooms—cater to every lifestyle. Have questions? Our FAQs page is your go-to resource for insight into our vibrant community. Dive in and discover all the details that make Casa Madrid a perfect home!",
  "property_floorplans_blurb": "At Casa Madrid in Chula Vista, CA, each thoughtfully designed floor plan offers a unique blend of comfort and style. Choose from spacious one, two, or three-bedroom layouts that perfectly fit your lifestyle. Dive into our selection and find the ideal home for you today!",
  "property_gallery_blurb": "At Casa Madrid in Chula Vista, CA, our vibrant community invites you to visualize life in stylish one, two, or three-bedroom apartments. Picture relaxing by the resort-style pool or savoring a meal at the BBQ area, all while enjoying modern amenities and easy freeway access. Your dream home awaits!",
  "property_interactivemap_blurb": "At Casa Madrid in Chula Vista, CA, embrace comfort and style with premium one, two, and three-bedroom floor plans. Enjoy resort-style amenities, including a sparkling pool, BBQ area, and pet-friendly living, all designed for your lifestyle. Navigate your future home easily with our interactive community map today!",
  "property_pets_blurb": "At Casa Madrid in Chula Vista, CA, your furry companions are part of the family. With a welcoming atmosphere for pets up to 30 lbs, indulge in a vibrant community that celebrates both comfort and companionship—just $50 per month per pet. Discover life with your pets at Casa Madrid today!",
  "property_referafriend_blurb": "At Casa Madrid in vibrant Chula Vista, CA, we offer thoughtfully designed one, two, and three-bedroom floor plans perfect for every lifestyle. Embrace the joy of community living—great friends make great neighbors! Refer a friend today and share the exceptional experience waiting for you both at Casa Madrid.",
  "property_residentaccess_blurb": "Welcome to Casa Madrid in charming Chula Vista, CA! Our thoughtfully designed floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to all lifestyles. Residents can effortlessly manage their living experience through our convenient portal, where paying rent and scheduling maintenance is just a click away!",
  "property_reviews_blurb": "At Casa Madrid in Chula Vista, CA, our residents rave about our dedicated management team. One resident shared, \"Gabby is very professional and easy to contact,\" showcasing our commitment to quality service. Join in our community events while enjoying a modern, well-maintained apartment. See what our residents have to say about living at our community!",
  "property_created_at": "1770052506443",
  "property_scheduletour_blurb": "At Casa Madrid in vibrant Chula Vista, CA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Experience the perfect blend of comfort and convenience. Interested? Schedule a tour today and hear firsthand what our residents love about making Casa Madrid their home!",
  "property_thankyou_blurb": "Thank you for reaching out to Casa Madrid in beautiful Chula Vista, CA! Our stylish one, two, and three-bedroom apartments offer the perfect blend of comfort and elegance. A knowledgeable team member will be in touch soon to discuss how you can make Casa Madrid your next home.",
  "property_virtualtours_blurb": "Welcome to Casa Madrid in Chula Vista, CA, where your ideal living space awaits! With thoughtfully designed one, two, and three-bedroom floor plans, our community caters to every lifestyle. Experience the comfort and elegance through our virtual tour—your next home is just a click away!",
  "property_copyright": "2026 All Rights Reserved. Casa Madrid ",
  "property_seo_title_home": "Casa Madrid  |  Apartments in Chula Vista, CA",
  "property_seo_description_home": "Experience resort-style living at Casa Madrid in Chula Vista! Choose from spacious 1, 2, or 3-bedroom apartments with modern amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Chula Vista, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Casa Madrid in Chula Vista, CA. Choose from stunning one, two, or three-bedroom floor plans tailored just for you!",
  "property_seo_title_amenities": "Amenities | Chula Vista, CA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Casa Madrid in Chula Vista! Enjoy resort-style amenities, modern finishes, and easy freeway access. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Chula Vista, CA",
  "property_seo_description_gallery": "Step into Casa Madrid in Chula Vista! Picture your life by the resort-style pool, cozy BBQ area, and modern features. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Casa Madrid  Apartments",
  "property_seo_description_virtualtours": "Step inside Casa Madrid in Chula Vista! Take a virtual tour of our stylish one, two, and three-bedroom apartments—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Casa Madrid  Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at Casa Madrid, Chula Vista! Enjoy resort-style living and great amenities. Start your journey with our interactive map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Chula Vista, CA",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle of Chula Vista at Casa Madrid! Dive into local favorites and scenic spots just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Casa Madrid ",
  "property_seo_description_contact": "Discover your perfect home at Casa Madrid, Chula Vista! Choose from 1, 2, or 3 bedrooms. Contact our leasing team for details!",
  "property_seo_title_faqs": "FAQs | Apartments in Chula Vista, CA",
  "property_seo_description_faqs": "Find answers to your questions about Casa Madrid in Chula Vista, CA. From floor plans to amenities, explore all the details of your future home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Chula Vista, CA",
  "property_seo_description_reviews": "Experience life at Casa Madrid in Chula Vista! Dive into resident reviews and discover why our community is the perfect blend of comfort and convenience.",
  "property_seo_title_applynow": "Apply Now | Apartments in Chula Vista, CA",
  "property_seo_description_applynow": "Experience sleek living at Casa Madrid in Chula Vista! Choose from spacious 1, 2, or 3-bedroom layouts with resort-style amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Casa Madrid ",
  "property_seo_description_residentaccess": "Experience convenience at Casa Madrid! Access the resident portal to pay rent, schedule maintenance, and manage your living experience.",
  "property_seo_title_referafriend": "Refer A Friend | Casa Madrid ",
  "property_seo_description_referafriend": "Refer a friend to Casa Madrid in Chula Vista, CA! Great friends make great neighbors—share the joy of community living and enjoy exclusive rewards today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Casa Madrid ",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Casa Madrid in Chula Vista, CA. Schedule your tour today to uncover your future home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Casa Madrid ",
  "property_seo_description_privacy": "At Casa Madrid in Chula Vista, your privacy matters. Learn how we protect your information and maintain a safe living environment. View our full policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Casa Madrid ",
  "property_seo_description_accessibility": "Experience Casa Madrid in Chula Vista, CA—where digital inclusion meets comfort. Join us in making accessibility a priority for all residents!",
  "property_seo_title_sitemap": "Sitemap | Casa Madrid ",
  "property_seo_description_sitemap": "Uncover every corner of Casa Madrid in Chula Vista, CA! Navigate our sitemap for easy access to amenities, floor plans, and community features.",
  "property_seo_title_thankyou": "Thank You | Casa Madrid ",
  "property_seo_description_thankyou": "Thank you for reaching out to Casa Madrid in Chula Vista! Our team will connect you soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Chula Vista, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293667463",
  "amenities": [
    {
      "id": "custom_34e74674-614e-4eae-a9e0-8d678d831d5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0caf00f2-7d00-41ab-b5e7-ab3314c96893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_caa6345a-0e87-453c-b6bf-3c20ae4cd4e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d8e584fc-6cd2-4af9-9bae-6c7c50a15c9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f2146d1-efdf-4f05-adc6-76cf4a4d9a32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Dog/Cat Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_164b8399-832c-47e1-8a53-45802a71a0d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to 5 and 805 Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38fd37ef-5534-4d74-94a1-0c7ddbbdcdcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Tile Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00d4fdc6-779f-42ff-adf8-877d13256afd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Hard Surface Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52f86787-382f-4ae2-9808-972cb47a4460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64a7c23f-a17c-4b78-85ec-925e347082e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher and Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e05bd3e-fa33-489d-838d-108e727b0053",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Quiet, Dual‑Pane Vinyl Windows",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_473ac975-685d-424d-9ef2-e415b9abb8f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Keyless Entry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2a92ebb3-4d1e-4cdd-8fd6-8a9071706e52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91ca9da3-a4b1-40ee-8cef-e82489f423ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "external_id": "false",
      "title": "Cable/Internet Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_8f4a277591b45afbce3335c2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba80-ecdf-74c8-b5f2-164581cb0cc2.webp",
      "image_media": {
        "alt_text": "Casa Madrid monument sign with landscaping.",
        "public_id": "019eba80-ecdf-74c8-b5f2-164581cb0cc2",
        "storage_key": "property/6767906449167026/019eba80-ecdf-74c8-b5f2-164581cb0cc2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Casa Madrid, featuring a monument sign and lush landscaping.",
      "link": "false",
      "alt_text": "Casa Madrid monument sign with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032548/6a2c795b1de0c7.55939221982.jpg"
    },
    {
      "id": "ec_b571ddd9e6b6440d6b5a467b",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba80-d007-7388-a28d-3f5a36d40e70.webp",
      "image_media": {
        "alt_text": "Casa Madrid apartment building exterior with monument sign at dusk.",
        "public_id": "019eba80-d007-7388-a28d-3f5a36d40e70",
        "storage_key": "property/6767906449167026/019eba80-d007-7388-a28d-3f5a36d40e70.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Casa Madrid, where comfortable living meets convenience. Explore our beautiful community and find your perfect home.",
      "link": "false",
      "alt_text": "Casa Madrid apartment building exterior with monument sign at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032551/6a2c795d92ef01.42203376254.jpg"
    },
    {
      "id": "ec_e341c73e779fee5c63834194",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-edf9-754c-9db0-b99394931273.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with lush landscaping and palm trees.",
        "public_id": "019eba81-edf9-754c-9db0-b99394931273",
        "storage_key": "property/6767906449167026/019eba81-edf9-754c-9db0-b99394931273.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully landscaped grounds with tropical plants and mature trees, offering a serene outdoor environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with lush landscaping and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032531/6a2c7949c21091.76416914143.jpg"
    },
    {
      "id": "ec_1cdc30d9af5b666f6a069b2f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba80-d258-73a3-910f-d1efd07aa6d9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and light wood floors.",
        "public_id": "019eba80-d258-73a3-910f-d1efd07aa6d9",
        "storage_key": "property/6767906449167026/019eba80-d258-73a3-910f-d1efd07aa6d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, a sleek subway tile backsplash, stainless steel appliances, and durable wood-look flooring.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and light wood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032546/6a2c7958d93079.35867549423.jpg"
    },
    {
      "id": "ec_ea5ef592417ad47b08524431",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba80-d1f6-720d-8968-7b926f7332f6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a blue tile backsplash.",
        "public_id": "019eba80-d1f6-720d-8968-7b926f7332f6",
        "storage_key": "property/6767906449167026/019eba80-d1f6-720d-8968-7b926f7332f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully updated kitchen featuring sleek white cabinetry, a full suite of stainless steel appliances, and a striking blue subway tile backsplash. Perfect for culinary adventures.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a blue tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032916/6a2c7a2b51ad58.80295722212.jpg"
    },
    {
      "id": "ec_83a1febd19c1d12eb281db29",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-1ef0-71ae-9cf7-0ccf4c2aa7ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a blue tiled backsplash.",
        "public_id": "019eba81-1ef0-71ae-9cf7-0ccf4c2aa7ce",
        "storage_key": "property/6767906449167026/019eba81-1ef0-71ae-9cf7-0ccf4c2aa7ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and contemporary kitchen space featuring white cabinetry, a sleek stainless steel refrigerator and dishwasher, and a vibrant blue tiled backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a blue tiled backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032544/6a2c7956c48cc1.63453988380.jpg"
    },
    {
      "id": "ec_d89580a0d0f44fb9b0345037",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-1980-770c-a044-db6d2487bf25.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and stainless steel appliances next to a living area with wood flooring.",
        "public_id": "019eba81-1980-770c-a044-db6d2487bf25",
        "storage_key": "property/6767906449167026/019eba81-1980-770c-a044-db6d2487bf25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and airy apartment featuring a modern kitchen with white cabinetry and stainless steel appliances, flowing seamlessly into a spacious living area.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets and stainless steel appliances next to a living area with wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032914/6a2c7a293070d4.86280384308.jpg"
    },
    {
      "id": "ec_e239ac2c32d1dad52c0c854a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-721b-764f-8515-d1d3f67f01ea.webp",
      "image_media": {
        "alt_text": "Empty living room with hardwood floors and a ceiling fan.",
        "public_id": "019eba81-721b-764f-8515-d1d3f67f01ea",
        "storage_key": "property/6767906449167026/019eba81-721b-764f-8515-d1d3f67f01ea.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring modern hardwood flooring, a ceiling fan, and a large window allowing natural light.",
      "link": "false",
      "alt_text": "Empty living room with hardwood floors and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032535/6a2c794e4ffa10.95270647229.jpg"
    },
    {
      "id": "ec_0f148d2ac65b437565e0e2e2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-6539-700e-8aa7-ea67048230f0.webp",
      "image_media": {
        "alt_text": "Living area and kitchen view in a multifamily apartment with wood-look flooring and white walls.",
        "public_id": "019eba81-6539-700e-8aa7-ea67048230f0",
        "storage_key": "property/6767906449167026/019eba81-6539-700e-8aa7-ea67048230f0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy living space featuring wood-look flooring, a ceiling fan, and an open-concept kitchen with white cabinetry.",
      "link": "false",
      "alt_text": "Living area and kitchen view in a multifamily apartment with wood-look flooring and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032540/6a2c7952a081e4.02993272893.jpg"
    },
    {
      "id": "ec_e209bd3709d4a43029384860",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-2a3d-7647-a4e6-29165684ea03.webp",
      "image_media": {
        "alt_text": "Spacious living area with two ceiling fans and wood-look flooring.",
        "public_id": "019eba81-2a3d-7647-a4e6-29165684ea03",
        "storage_key": "property/6767906449167026/019eba81-2a3d-7647-a4e6-29165684ea03.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment featuring modern finishes, ceiling fans, and ample natural light.",
      "link": "false",
      "alt_text": "Spacious living area with two ceiling fans and wood-look flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032912/6a2c7a271b7780.78622643470.jpg"
    },
    {
      "id": "ec_e9eb686db919b5bd69d7986e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-6664-7608-9aca-d026b43f86ef.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and a ceiling fan.",
        "public_id": "019eba81-6664-7608-9aca-d026b43f86ef",
        "storage_key": "property/6767906449167026/019eba81-6664-7608-9aca-d026b43f86ef.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring modern wood-look flooring and a stylish ceiling fan, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty bedroom with wood-look flooring and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032538/6a2c7950918448.12091443825.jpg"
    },
    {
      "id": "ec_9b0b0a26829fb01cddb5cdcf",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-3715-71e9-bad8-f71ae633868d.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, window overlooking street, and closet.",
        "public_id": "019eba81-3715-71e9-bad8-f71ae633868d",
        "storage_key": "property/6767906449167026/019eba81-3715-71e9-bad8-f71ae633868d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, large window with blinds, and a sliding door closet. This room offers a bright and airy feel with modern wood-look flooring.",
      "link": "false",
      "alt_text": "Bedroom with ceiling fan, window overlooking street, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032542/6a2c7954ae2102.27895821260.jpg"
    },
    {
      "id": "ec_11aeaa57dbeb9cb9b15ff69a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-697c-77fe-aa46-98834ecef00e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019eba81-697c-77fe-aa46-98834ecef00e",
        "storage_key": "property/6767906449167026/019eba81-697c-77fe-aa46-98834ecef00e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom featuring a spacious vanity with ample counter space, a modern faucet, a toilet, and a white shower/tub combination.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032910/6a2c7a2522f4f6.34838371259.jpg"
    },
    {
      "id": "ec_2231e8a8441e51d0b4801f00",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-601e-73e0-a977-a063aa84b481.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with orange lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019eba82-601e-73e0-a977-a063aa84b481",
        "storage_key": "property/6767906449167026/019eba82-601e-73e0-a977-a063aa84b481.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our pristine swimming pool, complete with comfortable lounge chairs and shaded umbrellas, perfect for enjoying the California sun.",
      "link": "false",
      "alt_text": "Sparkling swimming pool with orange lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032857/6a2c7a174b5e00.95526695843.jpg"
    },
    {
      "id": "ec_edd3d283507d5a1a76287301",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-24b0-73bd-b8d3-0225a57fbdcf.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019eba82-24b0-73bd-b8d3-0225a57fbdcf",
        "storage_key": "property/6767906449167026/019eba82-24b0-73bd-b8d3-0225a57fbdcf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for a sunny day.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032859/6a2c7a19b275d6.49532371482.jpg"
    },
    {
      "id": "ec_c31367b106eec6281f1580bb",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-81fa-75ee-bd2c-f9c3081cf4e3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at sunset, surrounded by apartment buildings.",
        "public_id": "019eba82-81fa-75ee-bd2c-f9c3081cf4e3",
        "storage_key": "property/6767906449167026/019eba82-81fa-75ee-bd2c-f9c3081cf4e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and umbrellas. Enjoy a refreshing dip or soak up the sun in this beautiful community oasis.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at sunset, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033155/6a2c7aca4dd170.89209747421.jpg"
    },
    {
      "id": "ec_88e2fab71dad98dc6752fd6a",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-ae31-74fb-986c-a8bd6b140a2f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables and grills under orange umbrellas.",
        "public_id": "019eba82-ae31-74fb-986c-a8bd6b140a2f",
        "storage_key": "property/6767906449167026/019eba82-ae31-74fb-986c-a8bd6b140a2f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and cooking with our community barbecue grills and comfortable seating areas.",
      "link": "false",
      "alt_text": "Outdoor seating area with picnic tables and grills under orange umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033153/6a2c7ac7d6b380.21220025486.jpg"
    },
    {
      "id": "ec_a8271cfa679dd361b47544c2",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-17b4-720b-92bf-e2466637359f.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills, seating, and umbrellas.",
        "public_id": "019eba82-17b4-720b-92bf-e2466637359f",
        "storage_key": "property/6767906449167026/019eba82-17b4-720b-92bf-e2466637359f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining in our community grilling area, complete with modern grills and comfortable seating.",
      "link": "false",
      "alt_text": "Outdoor grilling area with two built-in grills, seating, and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033158/6a2c7acc564841.73960856726.jpg"
    },
    {
      "id": "ec_eb1992b7c4e03c52b89c81ae",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-0050-7149-8b18-4c40f639d47a.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills under a slatted pergola.",
        "public_id": "019eba82-0050-7149-8b18-4c40f639d47a",
        "storage_key": "property/6767906449167026/019eba82-0050-7149-8b18-4c40f639d47a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking at our community grilling station, featuring two premium stainless steel grills and comfortable seating areas.",
      "link": "false",
      "alt_text": "Outdoor grilling station with two stainless steel grills under a slatted pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033200/6a2c7acea33434.85750757359.jpg"
    },
    {
      "id": "ec_31817b5f7928a39f41cc8dd1",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-88c8-7333-b2f3-06b67220d987.webp",
      "image_media": {
        "alt_text": "Mailboxes in apartment building hallway with an office box on the right.",
        "public_id": "019eba81-88c8-7333-b2f3-06b67220d987",
        "storage_key": "property/6767906449167026/019eba81-88c8-7333-b2f3-06b67220d987.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient mail delivery is provided for residents in this apartment building's central mailbox area.",
      "link": "false",
      "alt_text": "Mailboxes in apartment building hallway with an office box on the right.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032533/6a2c794c1b4d63.40023954464.jpg"
    },
    {
      "id": "ec_6fa0f029e82739b3d4d8d111",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-a35d-7768-87cc-b707d4ad606f.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple stacked washers and dryers, and a row of front-loading washing machines.",
        "public_id": "019eba81-a35d-7768-87cc-b707d4ad606f",
        "storage_key": "property/6767906449167026/019eba81-a35d-7768-87cc-b707d4ad606f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for resident use.",
      "link": "false",
      "alt_text": "Laundry room with multiple stacked washers and dryers, and a row of front-loading washing machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032908/6a2c7a22ecf479.15847864219.jpg"
    },
    {
      "id": "ec_c0aa3ed20e6ed8f2ffd405d3",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-d3c1-7551-a9b5-c2143951efc2.webp",
      "image_media": {
        "alt_text": "Coffee station with Nespresso machine, cups, coffee pods, and snacks.",
        "public_id": "019eba81-d3c1-7551-a9b5-c2143951efc2",
        "storage_key": "property/6767906449167026/019eba81-d3c1-7551-a9b5-c2143951efc2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a complimentary coffee and snack from the convenient coffee station located in the community lounge.",
      "link": "false",
      "alt_text": "Coffee station with Nespresso machine, cups, coffee pods, and snacks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032901/6a2c7a1c3419b5.37758731640.jpg"
    },
    {
      "id": "ec_0b478987616bfb8bc4d22fa5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-c031-752b-bd7c-2bcac1feae30.webp",
      "image_media": {
        "alt_text": "Workstation with computers and bar stools, and a wet bar with a microwave and mini-fridge.",
        "public_id": "019eba81-c031-752b-bd7c-2bcac1feae30",
        "storage_key": "property/6767906449167026/019eba81-c031-752b-bd7c-2bcac1feae30.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "This communal workspace features a large counter with computers and bar stools, perfect for residents to get work done. A stylish wet bar with modern appliances is also available.",
      "link": "false",
      "alt_text": "Workstation with computers and bar stools, and a wet bar with a microwave and mini-fridge.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032904/6a2c7a1e792ca4.28235895277.jpg"
    },
    {
      "id": "ec_8252335ae1b5a88d68d4f615",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-af0b-74ba-8df8-2fac626ed42c.webp",
      "image_media": {
        "alt_text": "Community coffee bar and lounge area with a pool view.",
        "public_id": "019eba81-af0b-74ba-8df8-2fac626ed42c",
        "storage_key": "property/6767906449167026/019eba81-af0b-74ba-8df8-2fac626ed42c.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our community lounge, complete with a view of the sparkling swimming pool.",
      "link": "false",
      "alt_text": "Community coffee bar and lounge area with a pool view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/032906/6a2c7a20b2e4e3.19657795983.jpg"
    },
    {
      "id": "ec_92acea6953a14ab6809a2f6d",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba83-0800-74da-9d36-5893638dbc56.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with U-shaped buildings, courtyard, and pool.",
        "public_id": "019eba83-0800-74da-9d36-5893638dbc56",
        "storage_key": "property/6767906449167026/019eba83-0800-74da-9d36-5893638dbc56.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover this multifamily property featuring U-shaped buildings, a central courtyard with a swimming pool, and ample parking. An ideal community setting.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily property with U-shaped buildings, courtyard, and pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033147/6a2c7ac1ccb461.64584473241.jpg"
    },
    {
      "id": "ec_181a58a78933c3f5e798993c",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-c52c-758d-81f7-74457e68f61e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and parking lot.",
        "public_id": "019eba82-c52c-758d-81f7-74457e68f61e",
        "storage_key": "property/6767906449167026/019eba82-c52c-758d-81f7-74457e68f61e.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial view showcases the apartment complex, highlighting the exterior buildings, a shimmering swimming pool area with lounge chairs, and ample parking.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a pool and parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033149/6a2c7ac3bb4ff7.67200781351.jpg"
    },
    {
      "id": "ec_09dfafcb62cce3c32eaff919",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba82-b913-7608-8207-9de2f3356e01.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with swimming pool and lounge chairs.",
        "public_id": "019eba82-b913-7608-8207-9de2f3356e01",
        "storage_key": "property/6767906449167026/019eba82-b913-7608-8207-9de2f3356e01.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience resort-style living with our sparkling swimming pool and comfortable lounge area, perfect for relaxing and enjoying the California sun.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/06/12/033151/6a2c7ac5a557f0.51843623745.jpg"
    },
    {
      "id": "ec_afbb62d70eb28f16183fde61",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fb183-e9d0-7451-aa92-1afe7436681e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and a beach-themed art print.",
        "public_id": "019fb183-e9d0-7451-aa92-1afe7436681e",
        "storage_key": "property/6767906449167026/019fb183-e9d0-7451-aa92-1afe7436681e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "staged casa kitchen",
      "link": "false",
      "alt_text": "staged casa kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/29/032606/6a6a6fedceea56.95824532875.png"
    },
    {
      "id": "ec_774b618a04ea03d743d95150",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fb183-e9ce-718e-b87f-b2adcb838c4d.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a white sofa, coffee table, and natural light from a large window.",
        "public_id": "019fb183-e9ce-718e-b87f-b2adcb838c4d",
        "storage_key": "property/6767906449167026/019fb183-e9ce-718e-b87f-b2adcb838c4d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "staged casa living room",
      "link": "false",
      "alt_text": "staged casa living room",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/29/032606/6a6a6fee9a99f4.76372435360.png"
    },
    {
      "id": "ec_e9d5c26b7be92122e30fa89e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fb183-ea22-740a-8f96-8eb8ffdeceba.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, vanity, and mirror.",
        "public_id": "019fb183-ea22-740a-8f96-8eb8ffdeceba",
        "storage_key": "property/6767906449167026/019fb183-ea22-740a-8f96-8eb8ffdeceba.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "staged casa bathroom",
      "link": "false",
      "alt_text": "staged casa bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/29/032607/6a6a6fef53e174.70054352407.png"
    },
    {
      "id": "ec_5b02d5aec9246cc673cb74a6",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fb183-e9d3-74b8-b5f4-2122c7c15e67.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019fb183-e9d3-74b8-b5f4-2122c7c15e67",
        "storage_key": "property/6767906449167026/019fb183-e9d3-74b8-b5f4-2122c7c15e67.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "staged casa bedroom",
      "link": "false",
      "alt_text": "staged casa bedroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/27/2026/07/29/032608/6a6a6ff0354207.49330018755.png"
    },
    {
      "id": "ec_5b368c16d3d296902bea9cc5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019e98bb-b477-71aa-a9e2-a2e00b04ccc3.webp",
      "image_media": {
        "alt_text": "Decorative quatrefoil pattern with floral design and small star accents.",
        "public_id": "019e98bb-b477-71aa-a9e2-a2e00b04ccc3",
        "storage_key": "property/6767906449167026/019e98bb-b477-71aa-a9e2-a2e00b04ccc3.webp",
        "width": 551,
        "height": 547
      },
      "title": "Other",
      "description": "casa-madrid-icon-color-01",
      "link": "false",
      "alt_text": "casa-madrid-icon-color-01",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://medialibrarycf.entrata.com/18730/MLv3/3/21/2024/08/20/012644/66c4edf4366df6.20229694598.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_475a53f7-2ab6-445d-9373-cb6ffa750c29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Tacos El Gordo",
      "poi_type": "Restaurants",
      "poi_address": "556 Broadway, Chula Vista, CA 91910, USA",
      "poi_short_description": "No-frills Mexican counter-serve joint featuring Tijuana tacos, mulas, loaded fries & more.",
      "poi_long_description": "People say this Mexican restaurant serves delicious adobada tacos, al pastor, and carne asada fries. They highlight the authentic flavors, fresh ingredients, and reasonable prices. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-14e2-72a8-9c76-34248bddf773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-14e2-72a8-9c76-34248bddf773",
        "storage_key": "property/6767906449167026/019d08bd-14e2-72a8-9c76-34248bddf773.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rebrand.ly/taco-gordo",
      "poi_directions_map_url": "https://maps.google.com/?cid=3574953485129475139&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacos-el-gordo",
      "poi_latitude": "32.6290445",
      "poi_longitude": "-117.0890448",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-271-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5e3-779d-92f0-62695ea35644",
        "storage_key": "property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt2kEw-hN2YARQ-Sv-UDJnDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2f6e069b-21e9-4f32-b75e-a15380f5d8f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1093 Outer Rd, San Diego, CA 92154, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fries, and shakes. They highlight the fresh ingredients, consistent quality, and affordable prices. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-14b4-74cc-a20e-7096556ea0d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-14b4-74cc-a20e-7096556ea0d9",
        "storage_key": "property/6767906449167026/019d08bd-14b4-74cc-a20e-7096556ea0d9.webp",
        "width": 1242,
        "height": 752
      },
      "poi_business_url": "https://locations.in-n-out.com/383",
      "poi_directions_map_url": "https://maps.google.com/?cid=13421418183475995117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "32.577003",
      "poi_longitude": "-117.0803193",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5e3-779d-92f0-62695ea35644",
        "storage_key": "property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQ0xO5VN2YAR7SEOaLp0Qro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1ad9a85c-a1d4-4bf2-887e-0e66bc1a0ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "512 H St, Chula Vista, CA 91910, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and bread. They also highlight the fast service, friendly staff, and reasonable prices.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-1465-710e-ad05-ddcb377ae8d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1465-710e-ad05-ddcb377ae8d9",
        "storage_key": "property/6767906449167026/019d08bd-1465-710e-ad05-ddcb377ae8d9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/chula-vista/512-h-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=2778928896621617390&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.631666",
      "poi_longitude": "-117.0856629",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-210-0568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5e3-779d-92f0-62695ea35644",
        "storage_key": "property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZJXH7pN2YAR7iAzqxu9kCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6212828d-efcd-4200-a0bf-8d8a08f434ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "El Pastor Del Rica",
      "poi_type": "Restaurants",
      "poi_address": "645 Broadway, Chula Vista, CA 91910, USA",
      "poi_short_description": "Guadalajara-style Mexican fare for lunch and dinner (including tacos and quesadillas) served at clean tables.",
      "poi_long_description": "People say this restaurant serves delicious tacos, including al pastor, carne asada, and suadero, and offers a variety of salsas. They highlight the fast service and efficient system, and the generous portions of meat in the tacos. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-1c4e-760c-9cc6-4a3775ae89b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1c4e-760c-9cc6-4a3775ae89b7",
        "storage_key": "property/6767906449167026/019d08bd-1c4e-760c-9cc6-4a3775ae89b7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9443463661825456519&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-pastor-del-rica",
      "poi_latitude": "32.626169",
      "poi_longitude": "-117.0871998",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-371-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5e3-779d-92f0-62695ea35644",
        "storage_key": "property/6767906449167026/019d08bc-d5e3-779d-92f0-62695ea35644.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgTiG3zlN2YARh3lqtCrsDYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2f3c7253-e485-4521-9737-7d40aedf0606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Las Americas Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "4211 Camino De La Plaza, San Diego, CA 92173, USA",
      "poi_short_description": "",
      "poi_long_description": "Shoppers say this outlet mall offers a wide variety of brand-name stores with great deals and discounts on clothing, accessories, and home goods. They also highlight the convenient location near the border, the abundance of parking, and the diverse food options, including food trucks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-1c4e-760c-9cc6-4dcec30b1952.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1c4e-760c-9cc6-4dcec30b1952",
        "storage_key": "property/6767906449167026/019d08bd-1c4e-760c-9cc6-4dcec30b1952.webp",
        "width": 965,
        "height": 637
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/las-americas",
      "poi_directions_map_url": "https://maps.google.com/?cid=14522455966983733237&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-americas-premium-outlets",
      "poi_latitude": "32.5436943",
      "poi_longitude": "-117.0414652",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-934-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5d7-705b-a51f-5759cd8dc698",
        "storage_key": "property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJka06sBpJ2YAR9T9ROsIgisk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2a79bf68-1ef8-4e8a-82e3-b15a62097ddf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Plaza Río",
      "poi_type": "Shopping & Retail",
      "poi_address": "P.º de los Héroes 98, Zona Urbana Rio Tijuana, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, shoes, electronics, and a supermarket, as well as restaurants, cafes, and a movie theater. They highlight the convenient location, ample parking, and family-friendly atmosphere. They also like the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-1d73-711a-a2b3-d6f99ddef5e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1d73-711a-a2b3-d6f99ddef5e6",
        "storage_key": "property/6767906449167026/019d08bd-1d73-711a-a2b3-d6f99ddef5e6.webp",
        "width": 1280,
        "height": 916
      },
      "poi_business_url": "http://www.plazariotijuana.com.mx/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17807708443727122566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "plaza-ro",
      "poi_latitude": "32.5283032",
      "poi_longitude": "-117.019839",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+52 664 200 2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5d7-705b-a51f-5759cd8dc698",
        "storage_key": "property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0XEmJFFJ2YARhlAU9HqwIfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9d32a2e1-5dce-446a-acdc-16ea896acb4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Westfield Plaza Bonita",
      "poi_type": "Shopping & Retail",
      "poi_address": "3030 Plaza Bonita Rd #2075, National City, CA 91950, USA",
      "poi_short_description": "Spacious indoor mall featuring a movie theater, plus familiar retail names.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing stores, and a food court with many options. They highlight the clean and pleasant atmosphere, and the festive decorations during holidays. They also like the convenient parking and the availability of entertainment options like a movie theater, arcade, and bowling alley.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-1d38-7582-af0b-9d334ae4d5e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-1d38-7582-af0b-9d334ae4d5e8",
        "storage_key": "property/6767906449167026/019d08bd-1d38-7582-af0b-9d334ae4d5e8.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/plazabonita",
      "poi_directions_map_url": "https://maps.google.com/?cid=17761010186256762769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-plaza-bonita",
      "poi_latitude": "32.656186",
      "poi_longitude": "-117.065741",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-267-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5d7-705b-a51f-5759cd8dc698",
        "storage_key": "property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8edfSftR2YARkcftm6nIe_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_33ba75a4-889c-421c-aedc-6b56f64bcd05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Calimax Plus Río",
      "poi_type": "Shopping & Retail",
      "poi_address": "P.º de los Héroes 2150, Zona Urbana Rio Tijuana, 22320 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this supermarket offers a wide variety of products, including fresh produce, meat, and prepared foods. They also highlight the clean and organized environment, and the friendly and helpful staff.\n\nOther reviews mention the checkout lines can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-249a-739a-90fc-a74202be0456.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-249a-739a-90fc-a74202be0456",
        "storage_key": "property/6767906449167026/019d08bd-249a-739a-90fc-a74202be0456.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tienda.calimax.com.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1427444761113898159&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "calimax-plus-ro",
      "poi_latitude": "32.523688",
      "poi_longitude": "-117.017748",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+52 664 634 3255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5d5-77cd-8b69-972017a4d6c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5d5-77cd-8b69-972017a4d6c1",
        "storage_key": "property/6767906449167026/019d08bc-d5d5-77cd-8b69-972017a4d6c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62kULURI2YARr6yvgnJNzxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_c7fd648a-3a36-4597-8f17-5c772ab3c62f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Otay Ranch Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2015 Birch Rd, Chula Vista, CA 91915, USA",
      "poi_short_description": "Shopping center with chain retailers, a movie theater & a weekly farmers' market.",
      "poi_long_description": "People say this shopping center offers a variety of stores and restaurants. They highlight the convenient free parking and the less crowded atmosphere compared to downtown. They also like the semi-higher end shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-2572-7287-a449-af673db15d75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-2572-7287-a449-af673db15d75",
        "storage_key": "property/6767906449167026/019d08bd-2572-7287-a449-af673db15d75.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.otayranchtowncenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8761337114418977484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "otay-ranch-town-center",
      "poi_latitude": "32.6235991",
      "poi_longitude": "-116.9679165",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 619-656-1393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-d5d7-705b-a51f-5759cd8dc698",
        "storage_key": "property/6767906449167026/019d08bc-d5d7-705b-a51f-5759cd8dc698.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx2uH_JlF2YARzJpjnq-Flnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a5f1de32-be9d-411b-8dbf-fec79e49b052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Southwestern College",
      "poi_type": "Education",
      "poi_address": "900 Otay Lakes Rd, Chula Vista, CA 91910, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-6a35-72b4-a026-a2910f7eb8ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-6a35-72b4-a026-a2910f7eb8ab",
        "storage_key": "property/6767906449167026/019d08bc-6a35-72b4-a026-a2910f7eb8ab.webp",
        "width": 655,
        "height": 412
      },
      "poi_business_url": "https://www.swccd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3872657386384238230&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwestern-college",
      "poi_latitude": "32.6400996",
      "poi_longitude": "-116.9978233",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 619-421-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd26-70e3-8a96-fc50750a46b4",
        "storage_key": "property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn-DmMZBP2YARlqY57F9xvjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_207f983d-fed6-4c79-8a77-9f9a56f61e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Centro Universitario de Educación de la Salud (CUES UABC)",
      "poi_type": "Education",
      "poi_address": "P.º del Centenario, Zona Urbana Rio Tijuana, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-2622-743f-bf29-e6ea8518837b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-2622-743f-bf29-e6ea8518837b",
        "storage_key": "property/6767906449167026/019d08bd-2622-743f-bf29-e6ea8518837b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.uabc.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15825207392652315762&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "centro-universitario-de-educacin-de-la-salud-cues-uabc",
      "poi_latitude": "32.53044",
      "poi_longitude": "-117.0164685",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+52 664 979 7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd26-70e3-8a96-fc50750a46b4",
        "storage_key": "property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJURYruSFJ2YARckztL0dunts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cf8aedfe-67e3-472b-b4aa-0f1e8f59f39b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Unus University SC",
      "poi_type": "Education",
      "poi_address": "Av Melchor Ocampo 2024, Zona Centro, 22000 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-2803-75ac-a76c-1d785009bc2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-2803-75ac-a76c-1d785009bc2c",
        "storage_key": "property/6767906449167026/019d08bd-2803-75ac-a76c-1d785009bc2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.unusuniversidad.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101835612750753155&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "unus-university-sc",
      "poi_latitude": "32.524018",
      "poi_longitude": "-117.0306283",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd26-70e3-8a96-fc50750a46b4",
        "storage_key": "property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zzOFE1I2YARgy32asbIs8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_74c10b37-81f3-4b70-a6aa-631f9be84196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "CUT University Campus Tijuana Altamira",
      "poi_type": "Education",
      "poi_address": "Av J 1010, Altamira, 22054 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-2cf3-724e-b6c4-b256cd049b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-2cf3-724e-b6c4-b256cd049b9c",
        "storage_key": "property/6767906449167026/019d08bd-2cf3-724e-b6c4-b256cd049b9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cutuniversidad.com.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=981602556808939851&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cut-university-campus-tijuana-altamira",
      "poi_latitude": "32.53235",
      "poi_longitude": "-117.05114",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+52 664 687 9454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd26-70e3-8a96-fc50750a46b4",
        "storage_key": "property/6767906449167026/019d08bc-dd26-70e3-8a96-fc50750a46b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmXCfFmU42YARS0k2HVNanw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_28166ca5-19e8-443e-be04-91f01fde4355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Sesame Place San Diego",
      "poi_type": "Entertainment",
      "poi_address": "2052 Entertainment Cir, Chula Vista, CA 91911, USA",
      "poi_short_description": "Family-friendly, Sesame Street-themed amusement park with rides, waterslides, parades & shows.",
      "poi_long_description": "People say this water park offers a variety of rides and attractions, including a wave pool, lazy river, and water slides. They also highlight the park is clean, family-friendly, and has plenty of seating, and the staff is friendly and helpful.\n\nOther reviews mention some rides can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-7853-76bf-b0f5-0177feaedcbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-7853-76bf-b0f5-0177feaedcbe",
        "storage_key": "property/6767906449167026/019d08bc-7853-76bf-b0f5-0177feaedcbe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sesameplace.com/san-diego?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7378431859405586499&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sesame-place-san-diego",
      "poi_latitude": "32.58763",
      "poi_longitude": "-117.0107593",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 619-943-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8hieUtP2YARQ4BL-650ZWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_6cf90f18-8b1a-4c02-bb66-96438ea52355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Living Coast Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1000 Gunpowder Point Dr PARKING, Chula Vista, CA 91910, USA",
      "poi_short_description": "Interactive center focuses on animals native to the San Diego Bay such as stingrays & sea turtles.",
      "poi_long_description": "People say this aquarium offers a variety of exhibits featuring sea turtles, sharks, rays, birds, and other wildlife, as well as a touch tank and educational experiences. They highlight the peaceful and relaxing vibe, and the opportunity to learn about the importance of environmental conservation. They also like the friendly and knowledgeable staff, and the convenient parking and shuttle service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-7b7c-729e-b9da-18acdfa946de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-7b7c-729e-b9da-18acdfa946de",
        "storage_key": "property/6767906449167026/019d08bc-7b7c-729e-b9da-18acdfa946de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thelivingcoast.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3005706386642889688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "living-coast-discovery-center",
      "poi_latitude": "32.6400525",
      "poi_longitude": "-117.1104169",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 619-409-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fY3Q_NN2YAR2Ov4oghqtik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_f1dbd624-65b4-4163-9e9e-9b08523298d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "DeVore Stadium",
      "poi_type": "Entertainment",
      "poi_address": "900 Otay Lakes Rd, Chula Vista, CA 91910, USA",
      "poi_short_description": "Sports stadium used for football games and other athletic events, as well as graduations.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-3048-7138-b6d8-8031a24e804c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3048-7138-b6d8-8031a24e804c",
        "storage_key": "property/6767906449167026/019d08bd-3048-7138-b6d8-8031a24e804c.webp",
        "width": 1280,
        "height": 841
      },
      "poi_business_url": "http://www.swccd.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7260894184158548384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "devore-stadium",
      "poi_latitude": "32.6430036",
      "poi_longitude": "-117.0000996",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-421-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-6b50-7035-8108-212ed86c5c8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b50-7035-8108-212ed86c5c8b",
        "storage_key": "property/6767906449167026/019d08bd-6b50-7035-8108-212ed86c5c8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDSx7zZNP2YARoFF4Zsrgw2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b3cfbf42-2156-419f-b4b1-7f0c40dbbbaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Tijuana Arch (Friendship Arch)",
      "poi_type": "Entertainment",
      "poi_address": "Av. Revolución 728, Zona Centro, 22000 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this historical landmark offers a variety of shops, restaurants, and bars, and is a popular spot for photos. They highlight the vibrant atmosphere, the iconic arch, and the convenient location near the border. They also like the lively music and entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-301f-74bb-960a-457dc3be2e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-301f-74bb-960a-457dc3be2e4a",
        "storage_key": "property/6767906449167026/019d08bd-301f-74bb-960a-457dc3be2e4a.webp",
        "width": 972,
        "height": 1074
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13747236036941002792&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tijuana-arch-friendship-arch",
      "poi_latitude": "32.5364658",
      "poi_longitude": "-117.0371205",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3rq3ABJ2YARKDhR8Vb-x74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_c7b57016-f6e0-440d-8e25-edf30a259a2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Friendly People Square",
      "poi_type": "Entertainment",
      "poi_address": "Av, P.º del Centenario, Zona Urbana Rio Tijuana, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this plaza offers delicious coffee and a variety of businesses. They highlight the peaceful and tranquil vibe, and the fun entertainment options at the casinos. They also like the punctual and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-30fd-7773-bed3-5e119eb4fa95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-30fd-7773-bed3-5e119eb4fa95",
        "storage_key": "property/6767906449167026/019d08bd-30fd-7773-bed3-5e119eb4fa95.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5355482495408543811&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "friendly-people-square",
      "poi_latitude": "32.5372542",
      "poi_longitude": "-117.0263038",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+52 664 973 0466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheo_HlZI2YARQxime_R-Uko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_c462fd85-f1a6-472f-ae06-b7a1a5143085",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "870 Amena Ct, Chula Vista, CA 91910, USA",
      "poi_short_description": "Chain gym featuring strength and cardio equipment, pools, and classes, plus personal training.",
      "poi_long_description": "Some gym goers say this gym is exceptionally clean and has a great jacuzzi.\n\nOther reviews mention the jacuzzi can be out of service and the pool can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-33fc-739c-9a26-d76a5aee54f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-33fc-739c-9a26-d76a5aee54f6",
        "storage_key": "property/6767906449167026/019d08bd-33fc-739c-9a26-d76a5aee54f6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/chula-vista-ca/bonita-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=15101593443159101727&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "32.6367416",
      "poi_longitude": "-117.019165",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-656-0018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP3OlPbpP2YARH9HdkTmjk9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_225a2f81-5628-496e-8e96-2a16315a61df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1030 3rd Ave, Chula Vista, CA 91911, USA",
      "poi_short_description": "Chains featuring an array of exercise equipment and fitness classes, plus amenities like saunas.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including a sauna, steam room, and indoor movie theater. They highlight the clean facilities and the good value for the price. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-8404-7667-bb9d-c83d2d8e7e75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-8404-7667-bb9d-c83d2d8e7e75",
        "storage_key": "property/6767906449167026/019d08bc-8404-7667-bb9d-c83d2d8e7e75.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/ca/chula-vista/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14151199674653887842&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.6161141",
      "poi_longitude": "-117.0713961",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 619-565-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9vxhntO2YARYk1euSApY8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_39a0a502-eca3-43ad-8c60-849fefba7418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1210 Broadway, Chula Vista, CA 91911, USA",
      "poi_short_description": "Chain fitness center offering weights, massage beds, and tanning, as well as a cardio area.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, clean showers and lockers, and friendly, helpful staff. They also highlight the welcoming and inclusive atmosphere, with many mentioning the \"lunk alarm\" as a fun and lighthearted touch.\n\nSome reviews mention the showers can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-3833-7245-9ac0-a3adb5dc7b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3833-7245-9ac0-a3adb5dc7b88",
        "storage_key": "property/6767906449167026/019d08bd-3833-7245-9ac0-a3adb5dc7b88.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/chula-vista-broadway-ave-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9874736841622413875&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.6060852",
      "poi_longitude": "-117.08134",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 619-869-8368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cWZ7ipM2YARM-Jdv9YcCok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_16673cb0-cfdb-4df6-b12e-88ec74d4ef39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1910 Sweetwater Rd, National City, CA 91950, USA",
      "poi_short_description": "Modern fitness club offering cardio machines, weights, a pool, basketball courts, a track and classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-3a28-74ed-a09b-c12773bb88cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3a28-74ed-a09b-c12773bb88cd",
        "storage_key": "property/6767906449167026/019d08bd-3a28-74ed-a09b-c12773bb88cd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=831&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7934654638276199017&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.6594455",
      "poi_longitude": "-117.079684",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-474-6392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWa-pgJS2YARacLbmVqOHW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4f387e13-f81c-45ee-b24a-004f9ac5bc46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "TG The Gym Chula Vista",
      "poi_type": "Health and Wellness",
      "poi_address": "320 3rd Ave, Chula Vista, CA 91910, USA",
      "poi_short_description": "Spacious facility for weight lifting and fitness enthusiasts with a large variety of equipment.",
      "poi_long_description": "People say this gym offers a variety of equipment and amenities, including saunas, cold plunge tubs, and massage chairs. They also highlight the supportive community and the availability of a private area with a premium membership.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-3ffe-707b-8334-3c36139d6426.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-3ffe-707b-8334-3c36139d6426",
        "storage_key": "property/6767906449167026/019d08bd-3ffe-707b-8334-3c36139d6426.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thegymchulavista.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=681921034836107699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tg-the-gym-chula-vista",
      "poi_latitude": "32.6399497",
      "poi_longitude": "-117.0798679",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 619-947-6678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0LvE9ZN2YARs-FFdpGrdgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8c885aa7-7201-416d-adb5-31d8ce44e7e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Sport Unit Benito Juárez",
      "poi_type": "Health and Wellness",
      "poi_address": "5 de Mayo y o Av. F 233, Zona Nte., 22000 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-42fd-74d9-a4ee-8fbe12c662c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-42fd-74d9-a4ee-8fbe12c662c7",
        "storage_key": "property/6767906449167026/019d08bd-42fd-74d9-a4ee-8fbe12c662c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17315587783410018858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-unit-benito-jurez",
      "poi_latitude": "32.5399848",
      "poi_longitude": "-117.0462417",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4cPCA9J2YARKmo_21hTTfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_4327d853-67ab-40bb-ba4b-55957794d7f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Sharp Chula Vista Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "751 Medical Center Ct, Chula Vista, CA 91911, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-7d1b-702e-bad8-5fae43c18e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bc-7d1b-702e-bad8-5fae43c18e79",
        "storage_key": "property/6767906449167026/019d08bc-7d1b-702e-bad8-5fae43c18e79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sharp.com/locations/hospitals/sharp-chula-vista?utm_source=google&utm_medium=organic&utm_campaign=yext&y_source=1_ODQ4MzMzNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5032651310012145622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sharp-chula-vista-medical-center",
      "poi_latitude": "32.6185317",
      "poi_longitude": "-117.0223143",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 619-502-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e309-7665-9571-98f7de7cac98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e309-7665-9571-98f7de7cac98",
        "storage_key": "property/6767906449167026/019d08bc-e309-7665-9571-98f7de7cac98.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QyspAdP2YAR1p-ty7OR10U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_55f73ef0-9923-44ca-bde9-d91df82d5659",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "ISSSTECALI HOSPITAL El Mirador",
      "poi_type": "Health and Wellness",
      "poi_address": "Av Paseo Costa del Pacífico 3011, El Mirador, 22520 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-461b-75f9-a14d-1e2403d71ba7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-461b-75f9-a14d-1e2403d71ba7",
        "storage_key": "property/6767906449167026/019d08bd-461b-75f9-a14d-1e2403d71ba7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://coronavirus.gob.mx/contacto/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5010377110912767765&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "issstecali-hospital-el-mirador",
      "poi_latitude": "32.5312741",
      "poi_longitude": "-117.0915408",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+52 686 304 8048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e309-7665-9571-98f7de7cac98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e309-7665-9571-98f7de7cac98",
        "storage_key": "property/6767906449167026/019d08bc-e309-7665-9571-98f7de7cac98.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJExhjTxY_2YARFRe0rm9viEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0a060872-1cf7-429f-8cc3-61cf73e39fc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Parque Teniente Guerrero",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "C. Carrillo Puerto 7428, Zona Centro, 22000 Tijuana, B.C., Mexico",
      "poi_short_description": "Charming city park with manicured lawns, shaded walkways, a playground, fountain & picnic areas.",
      "poi_long_description": "People say this park offers a playground, live music, and various food vendors. They also highlight the family-friendly and peaceful atmosphere, and the opportunity to relax and enjoy a picnic.\n\nSome reviews mention there can be issues with homeless people in the vicinity.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-4a65-7554-bb41-f9aa2ddedbca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4a65-7554-bb41-f9aa2ddedbca",
        "storage_key": "property/6767906449167026/019d08bd-4a65-7554-bb41-f9aa2ddedbca.webp",
        "width": 1280,
        "height": 1145
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11616735632584382807&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parque-teniente-guerrero",
      "poi_latitude": "32.5327254",
      "poi_longitude": "-117.0455212",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e2b1-763e-9605-09525b146d2a",
        "storage_key": "property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ910MJAhJ2YARV5nQfYLvNqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2af53e69-bf67-4753-a830-c0cd70406e2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Silver Strand State Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 CA-75, Coronado, CA 92118, USA",
      "poi_short_description": "Sandy space with ocean & bay shorelines offering fishing, swimming & picnicking, plus RV camping.",
      "poi_long_description": "People say this state park offers a beautiful beach with both ocean and bay access, perfect for relaxing, swimming, and camping. They highlight the peaceful and scenic atmosphere, especially during sunset, and the abundance of shells and sand dollars. They also like the convenient parking and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-4ab5-764a-9a19-0c19ef97c748.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4ab5-764a-9a19-0c19ef97c748",
        "storage_key": "property/6767906449167026/019d08bd-4ab5-764a-9a19-0c19ef97c748.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.parks.ca.gov/?page_id=654",
      "poi_directions_map_url": "https://maps.google.com/?cid=4169918669682174207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "silver-strand-state-beach",
      "poi_latitude": "32.6399649",
      "poi_longitude": "-117.1416731",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 619-435-5184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e2b1-763e-9605-09525b146d2a",
        "storage_key": "property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPa43HZ9S2YAR_-is2O-G3jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_429647eb-3e9c-4726-84fa-dec7bee3b842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Rohr Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4548 Sweetwater Rd, Bonita, CA 91902, USA",
      "poi_short_description": "Green space with a playground & fields plus a walking trail, model train rides & an equestrian ring.",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds, a dog park, picnic areas, walking trails, and sports facilities. They highlight the spacious, clean, and well-maintained grounds, as well as the ample parking and shady trees. They also like the peaceful and relaxing atmosphere, perfect for outdoor activities and family gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-4aae-70fd-b0a1-ce5406477ca2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4aae-70fd-b0a1-ce5406477ca2",
        "storage_key": "property/6767906449167026/019d08bd-4aae-70fd-b0a1-ce5406477ca2.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.chulavistaca.gov/departments/public-works/parks/locations-features-amenities-photos/rohr-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396197976918549412&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rohr-park",
      "poi_latitude": "32.665027",
      "poi_longitude": "-117.0327482",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 619-409-5979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e2b1-763e-9605-09525b146d2a",
        "storage_key": "property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50_TUitQ2YARpGPpP3gl40o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7f3d5e72-d25b-457c-934d-39318b31e499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Bonita Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5540 Sweetwater Rd, Bonita, CA 91902, USA",
      "poi_short_description": "This 18-hole golf course features a driving range, plus a restaurant & a pro shop.",
      "poi_long_description": "People say this golf course offers a fun and challenging layout with well-maintained greens. They also highlight the great value, especially with twilight rates, and the delicious food and drinks at the bar and grill.\n\nSome reviews mention the course can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-4dbc-75f7-aa9b-8956ae729481.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-4dbc-75f7-aa9b-8956ae729481",
        "storage_key": "property/6767906449167026/019d08bd-4dbc-75f7-aa9b-8956ae729481.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "https://new.bonitagolf.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13477797755548415&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bonita-golf-course",
      "poi_latitude": "32.679997",
      "poi_longitude": "-117.014849",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 619-267-1103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-6b72-71f4-a362-a61d3567f272.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bd-6b72-71f4-a362-a61d3567f272",
        "storage_key": "property/6767906449167026/019d08bd-6b72-71f4-a362-a61d3567f272.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdGiIDxQ2YAR__KSU_zhLwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_bcb54721-b55d-4049-b110-ab658c79e302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Kimball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E 12th St, National City, CA 91950, USA",
      "poi_short_description": "Sprawling green space offering playgrounds, a skate park and baseball diamonds for picnics as well as walks, bike rides and dog-walking.",
      "poi_long_description": "People say this park offers baseball fields, a skate park, picnic benches, and shaded areas with trees. They highlight the park is large, clean, and great for families, with fun events throughout the year. They also like the convenient location near City Hall, the police department, the library, and a trolley stop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-53c7-74b7-a27f-f61b72b8f68b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-53c7-74b7-a27f-f61b72b8f68b",
        "storage_key": "property/6767906449167026/019d08bd-53c7-74b7-a27f-f61b72b8f68b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nationalcityca.gov/government/community-services/parks-fields",
      "poi_directions_map_url": "https://maps.google.com/?cid=16137213416083126131&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kimball-park",
      "poi_latitude": "32.67117",
      "poi_longitude": "-117.1041264",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-336-4241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e2b1-763e-9605-09525b146d2a",
        "storage_key": "property/6767906449167026/019d08bc-e2b1-763e-9605-09525b146d2a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1x9rizhS2YARc3dNchrm8t8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8f38360c-b7a9-4123-a92b-35b2b1aff978",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "San Ysidro Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92173, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-53a7-7091-bebb-167952f8c22e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-53a7-7091-bebb-167952f8c22e",
        "storage_key": "property/6767906449167026/019d08bd-53a7-7091-bebb-167952f8c22e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15273237464342774687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "san-ysidro-station",
      "poi_latitude": "32.5445683",
      "poi_longitude": "-117.0295524",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO63sAv1I2YARn8NWgI1w9dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_0fb6746f-1004-4aff-ad2b-a6791b8bba70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "H Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Chula Vista, CA 91910, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-53c6-70ac-81a8-7284747baee3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-53c6-70ac-81a8-7284747baee3",
        "storage_key": "property/6767906449167026/019d08bd-53c6-70ac-81a8-7284747baee3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5828331521537894250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-street-station",
      "poi_latitude": "32.6298929",
      "poi_longitude": "-117.0955721",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxh3OOlN2YARamd6lqNk4lA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_2ca4ad37-8917-45fc-8e3e-ccde1076dcca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Brown Field Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1424 Continental St, San Diego, CA 92154, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-562b-740f-86ac-c51e04a26ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-562b-740f-86ac-c51e04a26ffd",
        "storage_key": "property/6767906449167026/019d08bd-562b-740f-86ac-c51e04a26ffd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sandiego.gov/airports/brown",
      "poi_directions_map_url": "https://maps.google.com/?cid=17510797315609289157&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brown-field-municipal-airport",
      "poi_latitude": "32.5691884",
      "poi_longitude": "-116.9856305",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 619-424-0455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-e79e-760b-985c-3fe20cb36703.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-e79e-760b-985c-3fe20cb36703",
        "storage_key": "property/6767906449167026/019d08bc-e79e-760b-985c-3fe20cb36703.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-4X6zx5G2YARxWHB4mHZAvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_28a494a9-db46-4d3e-b8a1-13fec15a09fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Palm Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92154, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-5b67-70e6-8693-fbf4791e0b21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5b67-70e6-8693-fbf4791e0b21",
        "storage_key": "property/6767906449167026/019d08bd-5b67-70e6-8693-fbf4791e0b21.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10885703653882144754&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "palm-ave",
      "poi_latitude": "32.5842707",
      "poi_longitude": "-117.0840109",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0MDIR9M2YAR8ifRW8zJEZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_72cd48f6-5ab5-4886-8f35-e86c25ce9bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Beyer Blvd Trolley Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Diego, CA 92173, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-5ae6-7698-af0a-c878938f42be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5ae6-7698-af0a-c878938f42be",
        "storage_key": "property/6767906449167026/019d08bd-5ae6-7698-af0a-c878938f42be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5968008493196421621&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beyer-blvd-trolley-station",
      "poi_latitude": "32.557686",
      "poi_longitude": "-117.047066",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62XkhzxJ2YAR9al8zRqg0lI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9ece7110-8143-4a4e-9db3-1affed3939e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Torre Zentrum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Zona Río, 22010 Tijuana, Baja California, Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-5b38-744a-ae52-5701454b28a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5b38-744a-ae52-5701454b28a0",
        "storage_key": "property/6767906449167026/019d08bd-5b38-744a-ae52-5701454b28a0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9054887969787482089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "torre-zentrum",
      "poi_latitude": "32.5248001",
      "poi_longitude": "-117.0141126",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+52 664 634 3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6p68UNI2YAR6Q8kOKJsqX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e44f30f4-8f20-4bd4-b9eb-fbe6c96f6076",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Corporativo Central",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Av. Diego Rivera 2311, Zona Urbana Rio Tijuana, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-5de8-7568-90d7-0331bd227f79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-5de8-7568-90d7-0331bd227f79",
        "storage_key": "property/6767906449167026/019d08bd-5de8-7568-90d7-0331bd227f79.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1969084204129893518&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corporativo-central",
      "poi_latitude": "32.5242659",
      "poi_longitude": "-117.0127453",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+52 664 906 7428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_YR2UNI2YARjrz-p6aXUxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0e6166bd-69e4-4795-8319-3865805929da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Caliente Interactive",
      "poi_type": "Major Employers & Offices",
      "poi_address": "P.º del Centenario 9211-LOCAL 24, MODULO 4, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-611b-7692-9571-5a101e5fbd34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-611b-7692-9571-5a101e5fbd34",
        "storage_key": "property/6767906449167026/019d08bd-611b-7692-9571-5a101e5fbd34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.caliente.mx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10817438714970410030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "caliente-interactive",
      "poi_latitude": "32.5364112",
      "poi_longitude": "-117.025505",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3lRG1ZI2YARLoxesTJDH5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ee4a35d2-6757-451f-b2a9-673116475e53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "Torre Peninsula",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Dr. Atl, Zona Urbana Rio Tijuana, 22010 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bd-6208-7223-affd-d64ee86be826.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08bd-6208-7223-affd-d64ee86be826",
        "storage_key": "property/6767906449167026/019d08bd-6208-7223-affd-d64ee86be826.webp",
        "width": 1048,
        "height": 1155
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4160491009205240663&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "torre-peninsula",
      "poi_latitude": "32.5242924",
      "poi_longitude": "-117.0148302",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+52 664 900 7271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF4AnBkRI2YARV4PilocIvTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_236d8f55-b0ab-4c26-ad92-142ec1fd4309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "poi_name": "CORPORATIVO EL FLORIDO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Blvd. Agua Caliente 8582, Zona Centro, 22000 Tijuana, B.C., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://elflorido.com.mx/contacto/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4642152188054663181&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corporativo-el-florido",
      "poi_latitude": "32.5232168",
      "poi_longitude": "-117.0314838",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08bc-dd21-75dd-8811-6c4466313a14",
        "storage_key": "property/6767906449167026/019d08bc-dd21-75dd-8811-6c4466313a14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe97qG5VJ2YARDfBM4tE8bEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_2f297a18-36d0-4634-9aa8-2b944747cd11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_e93f69e5-8cd9-4c4f-a452-b263c528ca4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a5fee50f-780e-4ccb-8ffb-4beee0a1077c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_61119057-f4a6-40ae-b4d6-7b5a94b8a5a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_94ed96c0-66d8-49e1-aeef-e49f0715aae9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b3c813e4-7ed1-4d6b-a6c4-b9028d0c4cd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "james allen",
      "text": "The new management have done a great job with the property. The apts look more modern and is very well maintained. The manager at Casa Madrid ( Gabby) is very professional and easy to contact. I love the community events like raffles,  free ice cream and tacos.  Other apartments in neighborhood look at us with envy.",
      "date": "2025-08-18",
      "title": ""
    },
    {
      "id": "custom_8ec4b2a1-e4f6-44c0-87c4-700d1d0f18b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Carlos",
      "text": "I was two clicks away from throwing my laptop out the window. Helped me out like it was no big deal (it kind of was). Stephanie fixed my tech issue in five minutes after I spent an HOURS “troubleshooting” (aka panicking and clicking stuff). Apparently, she speaks fluent error message and IT. She didn’t even roll her eyes once. Would definitely call again in a crisis or tech problem. Casa madrid management is the best.",
      "date": "2025-06-17",
      "title": ""
    },
    {
      "id": "custom_9089b727-3833-410e-beb7-3d26ab97c728",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Jacqueline Sanchez",
      "text": "“I am so grateful for Stephanie, who guided us through the entire process of my father moving out of his apartment. She was always responsive, answering my calls quickly and providing the support we needed every step of the way. She also worked closely with Gabby from the office, who helped my father, my sister, and my brother-in-law apply for a newly remodeled three-bedroom apartment—and they were approved! Everything went smoothly, and now they are happily settled in their new home. I truly appreciate all the help and dedication from both Stephanie and Gabby. Thank you for making this transition so easy for us!”",
      "date": "2025-02-04",
      "title": ""
    },
    {
      "id": "custom_bd219f37-f6b9-474f-a803-943319d52e7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Jj Lamadrid",
      "text": "Stephanie was such an amazing help for my wife and myself. She helped her every step of the processing including all of the dumb questions I might’ve thrown at her. Great support, answer all my questions, and was able to get us in extremely quickly! Thank you to Stephanie and the team for such an amazing transition into our first apartment.",
      "date": "2026-02-19",
      "title": ""
    },
    {
      "id": "custom_a1d35149-de65-402f-b941-3c2d93ac3dd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Leslie Maldonado",
      "text": "Took a tour of the property it looked very nice clean and calm. The manager was very pleasant and friendly answered all my questions, gave me a tour of two different units both units were clean and upgraded.",
      "date": "2026-02-26",
      "title": ""
    },
    {
      "id": "custom_0d13ee18-2d43-487a-bcc3-93cbfbe0b910",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "4.0",
      "name": "Rosie Vega",
      "text": "Manager Stephanie attended to my request,  she is very efficient at her job, and the technicians are as well. We need someone like her in this apartments She is polite and kind person 😊",
      "date": "2025-11-07",
      "title": ""
    },
    {
      "id": "custom_9fce7e25-282d-4baa-abe1-eb2a43757be9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "james allen",
      "text": "The new management have done a great job with the property. The apts look more modern and is very well maintained. The manager at Casa Madrid ( Gabby) is very professional and easy to contact. I love the community events like raffles,  free ice cream and tacos.  Other apartments in neighborhood look at us with envy.",
      "date": "2025-08-18",
      "title": ""
    },
    {
      "id": "custom_25161972-938e-4757-a375-2453b0e28609",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Abby Torres",
      "text": "Absolutely love living at Casa Madrid Apartments! Such a quiet, peaceful community with an amazing management team and super friendly maintenance staff.",
      "date": "2026-01-30",
      "title": ""
    },
    {
      "id": "custom_2566e0f1-09c8-4ac4-a97d-efcd6c2cc54b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": " Aolanis Torres",
      "text": "Love that they have resident events that we actually enjoy. They did loteria night and it was fun. But they have done other fun events too. Manager & maintenance are so nice and caring. My neighbors are so amazing and sweet. This is the best community.",
      "date": "2026-10-05",
      "title": ""
    },
    {
      "id": "custom_363a9fd2-9389-4819-aeb7-d647d0c7ef09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": " Dulce Romero",
      "text": "Property always well maintained!",
      "date": "2026-09-28",
      "title": ""
    },
    {
      "id": "custom_0505d0e0-6e22-4d2e-bf31-736c2647081f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": " Patricia Garcia",
      "text": "Friendly service, prompt response to maintenance issues, and excellent customer service.",
      "date": "2026-09-27",
      "title": ""
    },
    {
      "id": "custom_cdf84fe2-4c52-43ca-85c8-8f28562016b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": " Dulce Piña",
      "text": "Excellent atmosphere!!",
      "date": "2026-09-28",
      "title": ""
    },
    {
      "id": "custom_4aea37f7-6867-46ec-afe0-7bd36aab017e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Inneth",
      "text": "Amazing modern apartments. Loved how spacious the rooms & living room is. Beautiful out door area and looks like a peaceful community.\n",
      "date": "2026-09-30",
      "title": ""
    },
    {
      "id": "custom_57835d2b-98b0-41b5-973f-9533bf2452f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Anna Pena",
      "text": "My husband and I had a wonderful experience moving into this community. The property manager was incredibly attentive and made the whole move-in process smooth and stress-free. The maintenance team is also very responsive and takes care of any apartment needs quickly. We are very happy living here and truly appreciate the excellent service. We highly recommend this community!v",
      "date": "2026-08-19",
      "title": ""
    },
    {
      "id": "custom_8965dd67-1ecb-4f4d-9912-14ec3f4bb9de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5.0",
      "name": "Cie P",
      "text": "Stephanie was incredibly kind and considerate. She lessened my anxiety level with her compassionate nature. She’s a true hidden gem of your company. 🩷\n❤️1\n",
      "date": "2026-07-19",
      "title": ""
    },
    {
      "id": "custom_7ac260f1-e205-4cd0-91d5-1db66dfcd86e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "rating": "5",
      "name": " Amy Belle",
      "text": "Friendly staff, super easy and quick application/approval & very clean units with lovely & constantly-updated amenities!",
      "date": "2026-07-12",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_cf92ec8d-aafa-4629-bf31-814aebf1d217",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d45db-f99d-717e-b426-b0213e688947.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45db-f99d-717e-b426-b0213e688947",
        "storage_key": "property/6767906449167026/019d45db-f99d-717e-b426-b0213e688947.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 - 650 Sq Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yNKHY3ndehx"
    },
    {
      "id": "custom_df8a4f7a-c4c4-4a40-833f-25819150e3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d45dc-0e06-740c-88b2-e7f76d5d897f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45dc-0e06-740c-88b2-e7f76d5d897f",
        "storage_key": "property/6767906449167026/019d45dc-0e06-740c-88b2-e7f76d5d897f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2x1- 725 Sq Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xcipSKhwtjA"
    },
    {
      "id": "custom_a0d27f3e-f74f-4123-b323-24ee751f2a43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019d45dc-22f2-7215-9e75-7148ca77c528.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d45dc-22f2-7215-9e75-7148ca77c528",
        "storage_key": "property/6767906449167026/019d45dc-22f2-7215-9e75-7148ca77c528.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3x2 - 950 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BqYmRVYA5mV"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ecc2c-5e40-74f9-9a81-4e4677ceb3b0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Casa Madrid  Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-chula-vista-casa-madrid",
      "search_query": "pet friendly apartments Chula Vista",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Chula Vista",
      "h2_subtitle": "Discover pet-friendly living at Casa Madrid in Chula Vista. Perfect for you and your furry friends with amazing amenities.",
      "page_copy": "Casa Madrid offers pet-friendly apartments in Chula Vista with features designed for both residents and their pets. Our community provides a pet-friendly atmosphere with amenities that make everyday living comfortable for you and your furry companions.\n\nSituated in the heart of Chula Vista, Casa Madrid provides exceptional amenities like a resort-style pool, dishwasher, and hard surface floors while welcoming pets as part of the community experience. Quiet, dual-pane windows create a comfortable home environment for you and your pets. With keyless entry, experience smooth access each day. Discover a place where modern living and pet-friendly features come together at Casa Madrid.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apts in Chula Vista | Casa Madrid",
      "seo_description": "Discover pet-friendly apartments in Chula Vista at Casa Madrid. Perfect for you and your pets with great amenities. Join our welcoming community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-with-pool-san-diego-county-casa-madrid",
      "search_query": "apartments with a pool San Diego County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in San Diego County",
      "h2_subtitle": "Experience unmatched leisure at Casa Madrid, featuring a resort-style pool in beautiful San Diego County.",
      "page_copy": "Dive into comfort at Casa Madrid, offering apartments with a pool in San Diego County. Our residents enjoy the serene environment of a resort-style pool that serves as the perfect oasis after a long day in the sunny California weather.\n\nLocated in charming Chula Vista, Casa Madrid provides more than just a pool. Our community boasts hard surface floors, keyless entry, a dishwasher, and quiet dual-pane vinyl windows, ensuring a comfortable and modern living experience. Make Casa Madrid your home and enjoy all the perks of upscale amenities while relishing the vibrant atmosphere of San Diego County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with a Pool in San Diego County | Casa Madrid",
      "seo_description": "Explore Casa Madrid's apartments with a pool in San Diego County. Enjoy luxury amenities and a resort-style pool. Perfect for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "chula-vista-apartments-with-dedicated-parking-casa-madrid",
      "search_query": "Chula Vista apartments with dedicated parking",
      "category": "Amenity",
      "h1_title": "Chula Vista Apartments with Dedicated Parking",
      "h2_subtitle": "Casa Madrid offers apartments in Chula Vista with convenient dedicated parking, ensuring ease and comfort for all residents.",
      "page_copy": "Discover the convenience of dedicated parking at Casa Madrid in Chula Vista. Our apartments offer not only modern living amenities but also the added benefit of stress-free parking, simplifying daily commutes and eliminating the hassle of searching for a spot.\n\nNestled in the vibrant city of Chula Vista, Casa Madrid combines functionality with comfort. Enjoy our key features, including quiet dual-pane windows, hard surface floors, and a resort-style pool. Moreover, with keyless entry and a dishwasher, everyday living is both seamless and efficient. Trust Casa Madrid to deliver a comprehensive living experience tailored to your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chula Vista Apts with Dedicated Parking | Casa Madrid",
      "seo_description": "Explore Casa Madrid's Chula Vista apartments featuring dedicated parking, providing convenience alongside modern amenities. Ideal living awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-with-dishwashers-near-91911-casa-madrid",
      "search_query": "apartments with dishwashers near 91911",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers Near 91911",
      "h2_subtitle": "Enjoy modern living at Casa Madrid with apartments featuring dishwashers, conveniently located near the 91911 area.",
      "page_copy": "Nestled near the vibrant area of 91911, Casa Madrid offers comfortable living with the convenience of in-unit dishwashers. Our well-designed apartments offer amenities that support a convenient modern lifestyle.\n\nIn addition to featuring dishwashers, Casa Madrid proudly offers dual-pane vinyl windows for a serene environment, hard surface floors, and a refreshing resort-style pool. Located in Chula Vista, enjoy keyless entry and spacious layouts designed for comfortable living. Experience ease and comfort at its finest at Casa Madrid.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Dishwashers Near 91911 | Casa Madrid",
      "seo_description": "Casa Madrid offers apartments near 91911 with dishwashers and more. Modern amenities enhance a convenient Chula Vista lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "easy-freeway-access-apartments-chula-vista-casa-madrid",
      "search_query": "easy freeway access apartments Chula Vista",
      "category": "Amenity",
      "h1_title": "Easy Freeway Access Apartments in Chula Vista",
      "h2_subtitle": "Casa Madrid's location in Chula Vista offers easy freeway access, making commuting and travel both quick and convenient.",
      "page_copy": "Casa Madrid features easy freeway access apartments in Chula Vista, providing our residents with unmatched convenience. Perfectly situated, our community ensures quick and efficient commuting options, allowing you more time to enjoy what truly matters.\n\nBeyond easy access to highways, Casa Madrid offers an array of amenities such as a resort-style pool, keyless entry, and hard surface floors. Our apartments also include dishwashers and dual-pane windows, delivering a blend of comfort and practicality. Move into Casa Madrid and discover stress-free travel and comfortable living in beautiful Chula Vista.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Easy Freeway Access Apts in Chula Vista | Casa Madrid",
      "seo_description": "Casa Madrid in Chula Vista offers easy freeway access apartments, ensuring convenient travel alongside modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-in-chula-vista-ca-casa-madrid",
      "search_query": "one bedroom apartments in Chula Vista CA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Chula Vista, CA",
      "h2_subtitle": "Casa Madrid offers spacious one bedroom apartments in Chula Vista, CA designed for comfort and convenience.",
      "page_copy": "Experience the perfect blend of comfort and style with Casa Madrid's one bedroom apartments in Chula Vista, CA. Our apartments cater to modern living needs, offering spacious layouts that include desirable amenities such as dishwashers, dual-pane windows, and hard surface floors.\n\nLocated in the heart of Chula Vista, Casa Madrid provides more than just a place to live. Residents can enjoy a resort-style pool and easy access to key local spots. With features like keyless entry, our one bedroom apartments deliver both convenience and tranquility, making them an ideal home choice in Chula Vista.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apts in Chula Vista, CA | Casa Madrid",
      "seo_description": "Find spacious one bedroom apartments in Chula Vista, CA with modern amenities at Casa Madrid. Comfort and convenience meet at our prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-91911-casa-madrid",
      "search_query": "two bedroom apartments near 91911",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 91911",
      "h2_subtitle": "Discover spacious two bedroom apartments at Casa Madrid, conveniently located near the 91911 area in Chula Vista.",
      "page_copy": "Casa Madrid offers spacious two bedroom apartments near the 91911 area, designed for those seeking comfort and convenience. Our community is designed with modern living in mind, offering amenities such as dishwashers, hard surface floors, and dual-pane windows.\n\nSituated in Chula Vista, Casa Madrid's two bedroom apartments provide residents with easy access to local attractions and key freeway routes. Enjoy peaceful living with our resort-style pool and keyless entry, making Casa Madrid the ideal choice for those looking to live near the bustling 91911 community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apts Near 91911 | Casa Madrid",
      "seo_description": "Explore two bedroom apartments near 91911 at Casa Madrid, offering modern amenities and convenient access in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-in-san-diego-county-casa-madrid",
      "search_query": "three bedroom apartments in San Diego County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in San Diego County",
      "h2_subtitle": "Casa Madrid provides three bedroom apartments nestled in San Diego County, offering comfortable living spaces with modern features.",
      "page_copy": "At Casa Madrid, discover three bedroom apartments located in the vibrant San Diego County. Our spacious apartments offer flexible layouts with modern amenities like dishwashers, garbage disposal, and dual-pane windows that enhance comfort and convenience.\n\nResiding in Chula Vista, Casa Madrid ensures easy access to San Diego County's diverse attractions. Residents can relax in our resort-style pool or enjoy the benefits of our keyless entry system. With a perfect blend of style, innovation, and prime location, Casa Madrid's three bedroom apartments offer an excellent living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apts in San Diego County | Casa Madrid",
      "seo_description": "Find spacious three bedroom apartments at Casa Madrid in San Diego County. Enjoy modern amenities and an ideal location in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-near-southwestern-college-chula-vista-casa-madrid",
      "search_query": "apartments near Southwestern College Chula Vista",
      "category": "School",
      "h1_title": "Apartments Near Southwestern College",
      "h2_subtitle": "Casa Madrid offers apartments conveniently located near Southwestern College in Chula Vista, with modern amenities and easy access to campus.",
      "page_copy": "Casa Madrid offers apartments conveniently located near Southwestern College in Chula Vista, with modern amenities and easy access to campus.\nLooking for apartments near Southwestern College Chula Vista? Casa Madrid provides an ideal living space just a short distance from the college campus. Our community offers modern amenities like a dishwasher, garbage disposal, and hard surface floors to support a convenient lifestyle.\n\nSituated in Chula Vista, our location ensures easy access to Southwestern College and other local conveniences. Enjoy a resort-style pool and keyless entry for a blend of leisure and convenience. Choose Casa Madrid for a comfortable and convenient lifestyle near Southwestern College.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Southwestern College | Casa Madrid",
      "seo_description": "Discover Casa Madrid, offering convenient apartments near Southwestern College, Chula Vista, with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-close-to-centro-universitario-de-educacion-de-la-salud-san-diego-casa-madrid",
      "search_query": "apartments close to Centro Universitario de Educación de la Salud San Diego County",
      "category": "School",
      "h1_title": "Apartments Close to Centro de Educación",
      "h2_subtitle": "Casa Madrid offers convenient apartments near the Centro Universitario de Educación de la Salud in San Diego County.",
      "page_copy": "Casa Madrid provides ideal living options for those seeking apartments close to Centro Universitario de Educación de la Salud in San Diego County. Our apartments boast modern amenities including a dishwasher and garbage disposal, catering to a convenient lifestyle.\n\nLocated in Chula Vista, Casa Madrid's prime location offers easy access to educational hubs like the Centro Universitario. Residents can also enjoy our resort-style pool, keyless entry, and quiet dual-pane vinyl windows. Casa Madrid is the perfect choice for anyone looking for comfort and proximity to the university in San Diego County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Centro de Educación San Diego | Casa Madrid",
      "seo_description": "Find comfortable, modern apartments near Centro Universitario de Educación de la Salud at Casa Madrid, Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "university-apartments-near-unus-university-sc-ca-casa-madrid",
      "search_query": "university apartments near Unus University SC CA",
      "category": "School",
      "h1_title": "University Apartments Near Unus University",
      "h2_subtitle": "Casa Madrid offers university apartments near Unus University SC, CA, perfect for students and faculty seeking convenience and modern living.",
      "page_copy": "If you're searching for university apartments near Unus University SC, CA, look no further than Casa Madrid. Located strategically in Chula Vista, Casa Madrid offers a prime location that makes commuting to Unus University effortless.\n\nOur apartments feature amenities such as hard surface floors, a dishwasher, and garbage disposal, combining comfort with modern living. Enjoy the resort-style pool and keyless entry for a luxurious and secure lifestyle. Choose Casa Madrid for an ideal blend of proximity and convenience, perfect for students and faculty at Unus University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "University Apts Near Unus University SC CA | Casa Madrid",
      "seo_description": "Discover Casa Madrid's university apartments near Unus University SC, CA, featuring modern amenities and a convenient Chula Vista location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-near-cut-university-campus-tijuana-altamira-91911-casa-madrid",
      "search_query": "apartments near CUT University Campus Tijuana Altamira 91911",
      "category": "School",
      "h1_title": "Apartments Near CUT University Campus",
      "h2_subtitle": "Casa Madrid provides ideal apartments near CUT University Campus Tijuana Altamira, located conveniently close to the 91911 area.",
      "page_copy": "Searching for apartments near CUT University Campus Tijuana Altamira? Casa Madrid in Chula Vista offers the perfect balance of proximity and comfort. Positioned within easy reach of the 91911 region, our community provides an excellent living choice for those seeking convenient access to the campus.\nOur apartments come equipped with modern conveniences like a dishwasher, garbage disposal, and hard-surface floors. Enjoy the serenity brought by our quiet dual-pane vinyl windows, and unwind at our resort-style pool. Casa Madrid ensures a pleasant, secure living experience with features like keyless entry, making it a top choice near CUT University Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near CUT University Campus Tijuana | Casa Madrid",
      "seo_description": "Explore Casa Madrid, offering apartments near CUT University Campus Tijuana Altamira in the 91911 area. Modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-near-sharp-chula-vista-medical-center-casa-madrid",
      "search_query": "apartments near Sharp Chula Vista Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Sharp Chula Vista Medical",
      "h2_subtitle": "Discover convenient apartments near Sharp Chula Vista Medical Center at Casa Madrid, offering a blend of comfort and location.",
      "page_copy": "For those looking to reside close to Sharp Chula Vista Medical Center, Casa Madrid offers the perfect solution. Nestled in the heart of Chula Vista, our apartments provide easy accessibility to the medical center, making it convenient for those who work nearby or visit the area.\n\nOur community features amenities that enhance your living experience, such as hard surface floors, a dishwasher, and a garbage disposal. Residents can relax by our resort-style pool and benefit from the quiet of our dual-pane vinyl windows. With keyless entry, Casa Madrid ensures a blend of convenience and security, making it a preferred choice near Sharp Chula Vista.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Sharp Chula Vista Medical | Casa Madrid",
      "seo_description": "Live at Casa Madrid with quick access to Sharp Chula Vista Medical Center. Comfortable and modern living in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-close-to-issstecali-hospital-el-mirador-casa-madrid",
      "search_query": "apartments close to ISSSTECALI HOSPITAL El Mirador Chula Vista",
      "category": "Hospital",
      "h1_title": "Apartments Close to ISSSTECALI Hospital",
      "h2_subtitle": "Casa Madrid offers apartments close to ISSSTECALI Hospital El Mirador. Enjoy modern amenities in a prime Chula Vista location.",
      "page_copy": "If you're seeking apartments close to ISSSTECALI Hospital El Mirador in Chula Vista, Casa Madrid is your ideal choice. With our prime location, commuting to the hospital is quick and straightforward, making it convenient for those who work nearby or visit the area.\n\nThe apartments at Casa Madrid are designed for comfort and convenience, featuring amenities like hard surface floors, a dishwasher, and garbage disposal. Residents enjoy peace of mind with our keyless entry system and the tranquility offered by dual-pane vinyl windows. Unwind at our resort-style pool, and savor the blend of comfort and proximity that Casa Madrid provides.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to ISSSTECALI Hospital El Mirador | Casa Madrid",
      "seo_description": "Discover Casa Madrid's apartments close to ISSSTECALI Hospital El Mirador. Modern living with excellent amenities in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-near-parque-teniente-guerrero-casa-madrid",
      "search_query": "apartments near parque teniente guerrero chula vista",
      "category": "Park",
      "h1_title": "Apartments Near Parque Teniente Guerrero",
      "h2_subtitle": "Explore Casa Madrid's apartments near Parque Teniente Guerrero in Chula Vista. Experience a blend of nature and modern living.",
      "page_copy": "Looking for the perfect blend of city living and natural beauty? Casa Madrid offers apartments near Parque Teniente Guerrero in Chula Vista. This prime location allows residents to enjoy the serenity of the park and the vibrancy of city life just moments away.\n\nOur community provides comfortable living with amenities such as hard surface floors, a dishwasher, and a garbage disposal. Relax by our resort-style pool or enjoy the quiet afforded by dual-pane vinyl windows. With keyless entry, Casa Madrid combines convenience and modern features, making it an excellent choice near Parque Teniente Guerrero.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Parque Teniente Guerrero | Casa Madrid",
      "seo_description": "Live near Parque Teniente Guerrero at Casa Madrid. Enjoy the balance of nature and modern amenities in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "chula-vista-apartments-close-to-silver-strand-state-beach-casa-madrid",
      "search_query": "chula vista apartments close to silver strand state beach",
      "category": "Park",
      "h1_title": "Chula Vista Apartments Near Silver Strand",
      "h2_subtitle": "Casa Madrid offers Chula Vista apartments close to Silver Strand State Beach. Enjoy coastal living with modern amenities.",
      "page_copy": "Casa Madrid is a top choice for those looking for Chula Vista apartments close to Silver Strand State Beach. Enjoy the convenience of coastal living with easy access to one of the area's most beautiful beaches, perfect for weekend getaways or daily strolls along the shore.\n\nOur apartments provide a comfortable, modern living experience boasting amenities like hard surface floors, a dishwasher, and garbage disposal. Relax in our resort-style pool or enjoy the quiet of your home with dual-pane vinyl windows. Casa Madrid's keyless entry enhances both security and convenience, making it the ideal home near the stunning Silver Strand State Beach.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chula Vista Apts Near Silver Strand | Casa Madrid",
      "seo_description": "Casa Madrid offers Chula Vista living close to Silver Strand State Beach. Enjoy modern conveniences and easy beach access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "rohr-park-nearby-rental-apartments-casa-madrid",
      "search_query": "rohr park nearby rental apartments chula vista",
      "category": "Park",
      "h1_title": "Rental Apartments Near Rohr Park",
      "h2_subtitle": "Discover Casa Madrid's rental apartments located near Rohr Park in Chula Vista. Enjoy serene park proximity with modern amenities at your doorstep.",
      "page_copy": "Searching for rental apartments with easy access to Rohr Park in Chula Vista? Casa Madrid is perfectly situated for those who value both nature and modern conveniences. Our prime location allows you to enjoy peaceful walks and recreational activities at the park anytime.\n\nCasa Madrid features amenities such as hard surface floors, a dishwasher, and garbage disposal, ensuring a comfortable living experience. Our dual-pane vinyl windows provide a quiet environment, while keyless entry adds an extra layer of convenience and ease. Enjoy relaxing at our resort-style pool and savor the blend of nature with modern living near Rohr Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rohr Park in Chula Vista | Casa Madrid",
      "seo_description": "Find rental apartments nearby Rohr Park at Casa Madrid. Experience modern living and park access in Chula Vista.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "kimball-park-proximate-apartments-casa-madrid",
      "search_query": "kimball park proximate apartments san diego county",
      "category": "Park",
      "h1_title": "Apartments Near Kimball Park",
      "h2_subtitle": "Casa Madrid offers apartments proximate to Kimball Park in San Diego County. Enjoy a vibrant community with nearby park access.",
      "page_copy": "Casa Madrid presents the ideal opportunity for those seeking apartments near Kimball Park in San Diego County. Experience a perfect blend of convenience and leisure, with the park just a short trip away, allowing for recreational activities and relaxation.\n\nOur community features modern amenities, including hard surface floors, a dishwasher, and garbage disposal to elevate your living experience. Enjoy the peace of dual-pane vinyl windows and the convenience of keyless entry. With a resort-style pool and the vibrant, accessible location near Kimball Park, Casa Madrid is an excellent choice for your next home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Proximate Apts to Kimball Park | Casa Madrid",
      "seo_description": "Discover Casa Madrid's apartments near Kimball Park in San Diego County. Enjoy convenience with park access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-near-san-ysidro-station-casa-madrid",
      "search_query": "apartments near San Ysidro Station Chula Vista",
      "category": "Transit",
      "h1_title": "Apartments Near San Ysidro Station",
      "h2_subtitle": "Explore Casa Madrid's apartments near San Ysidro Station in Chula Vista. Benefit from seamless transit access and modern living.",
      "page_copy": "Looking for conveniently located apartments near San Ysidro Station in Chula Vista? Casa Madrid offers an exceptional location that delivers both accessibility and comfort. With the station nearby, commuting becomes a breeze, letting you explore the best of the area with ease.\n\nOur community features modern amenities like hard surface floors, a dishwasher, and garbage disposal, ensuring a stylish and practical lifestyle. Enjoy the tranquil environment provided by dual-pane vinyl windows and the convenience of keyless entry. With a resort-style pool to relax in, Casa Madrid is the perfect choice for those valuing both convenience and comfort near San Ysidro Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chula Vista Apts Near San Ysidro Station | Casa Madrid",
      "seo_description": "Casa Madrid offers Chula Vista apartments near San Ysidro Station. Enjoy accessible transit and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "chula-vista-apartments-close-to-h-street-station",
      "search_query": "Chula Vista apartments close to H Street Station",
      "category": "Transit",
      "h1_title": "Apts Close to H Street Station",
      "h2_subtitle": "Discover Casa Madrid's Chula Vista apartments close to H Street Station. Convenient transit access meets comfortable living.",
      "page_copy": "For those seeking Chula Vista apartments close to H Street Station, Casa Madrid is the ideal choice. Our proximity to the station means convenient and time-saving commutes, unlocking numerous transit options.\n\nOur community offers modern amenities, including hard surface floors, a dishwasher, and garbage disposal for a contemporary lifestyle. Dual-pane vinyl windows ensure peace, while keyless entry provides added convenience. After a busy day, unwind at our resort-style pool. Casa Madrid combines the benefit of accessibility with the comfort of a well-appointed home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chula Vista Apts Near H Street Station | Casa Madrid",
      "seo_description": "Explore Casa Madrid's Chula Vista apartments close to H Street Station. Convenient living with modern amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "palm-ave-nearby-apartment-rentals-casa-madrid",
      "search_query": "Palm Ave nearby apartment rentals San Diego",
      "category": "Transit",
      "h1_title": "Apartment Rentals Near Palm Ave",
      "h2_subtitle": "Casa Madrid offers nearby apartment rentals close to Palm Ave in San Diego. Enjoy city access and modern amenities.",
      "page_copy": "In search of apartment rentals near Palm Ave in San Diego? Casa Madrid provides the perfect setting, balancing city connectivity with comfortable living. Located just a quick commute from Palm Ave, you'll enjoy the convenience of city life without sacrificing peace.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Rentals Near Palm Ave | Casa Madrid",
      "seo_description": "Find apartment rentals near Palm Ave at Casa Madrid in San Diego. Enjoy city convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162417",
      "property_id": "6767906449167026",
      "source": "custom",
      "page_item_url": "apartments-close-to-beyer-blvd-trolley-station-ca",
      "search_query": "apartments close to Beyer Blvd Trolley Station CA",
      "category": "Transit",
      "h1_title": "Apts Near Beyer Blvd Trolley Station",
      "h2_subtitle": "Casa Madrid offers apartments close to Beyer Blvd Trolley Station in CA. Experience effortless travel and modern comfort.",
      "page_copy": "Searching for apartments close to Beyer Blvd Trolley Station in CA? Discover Casa Madrid, where location and lifestyle converge seamlessly. With the trolley station nearby, commutes and city exploration become straightforward and convenient.\n\nOur community brings you thoughtful amenities like hard surface floors, a dishwasher, and garbage disposal, ensuring a modern and efficient home environment. Enjoy relaxation and tranquility with dual-pane vinyl windows and keyless entry, while the resort-style pool offers the perfect escape. Casa Madrid is designed to meet the needs of those who value both accessibility and luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Beyer Blvd Trolley Station | Casa Madrid",
      "seo_description": "Explore Casa Madrid's apts close to Beyer Blvd Trolley Station, CA. Enjoy transit ease and modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5732"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18224252747"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N4KZLQPB"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.liveatcasamadrid.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1396230\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "42075941129"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epm5z74w6d"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "00927850"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InFMTmEyWG4rdGpDZ09CVFZWY1Q2eGc9PSIsInZhbHVlIjoiMkpKVnc3RkVzWkNCQVhEOVZTVjdtQT09IiwibWFjIjoiYjRiNWZhYTlkYTQxNjgzZmNkZWNkZjIxNWYyZTVlMGQ1MGM1ZjcxOGEwYjM2NWZlN2Y2NTI5ZWVkYmFjZWRlNyJ9"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5732",
  "custom_repli_id": "18224252747",
  "custom_google_gtm_id": "GTM-N4KZLQPB",
  "custom_entrata_chatbot": "<script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncf.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.liveatcasamadrid.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncf.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1396230\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "42075941129",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8epm5z74w6d",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "00927850",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InFMTmEyWG4rdGpDZ09CVFZWY1Q2eGc9PSIsInZhbHVlIjoiMkpKVnc3RkVzWkNCQVhEOVZTVjdtQT09IiwibWFjIjoiYjRiNWZhYTlkYTQxNjgzZmNkZWNkZjIxNWYyZTVlMGQ1MGM1ZjcxOGEwYjM2NWZlN2Y2NTI5ZWVkYmFjZWRlNyJ9",
  "custom_audioeye_site_id": "be9ffebe-a908-427d-80cc-23d43db5f613",
  "custom_audioeye_site_hash": "95cd21a2d19f236c67b0b5b1bcace6b3"
};

export const generatedAt = '2026-10-21T13:17:52.799Z';
